import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Vuex from 'vuex'
import axios from 'axios'
import DynamicComponent from '@/components/DynamicComponent.vue'
import VueLazyload from 'vue-lazyload'
import router from './router/index'
import VueRouter from 'vue-router'
import * as constants from './constants'
import * as menuConstants from './constants/menu'
import packageJson from '../package.json'

const version = packageJson.version

// import braintree from '../node_modules/braintree-web-drop-in/index.js';
// import Vuelidate from 'vuelidate'

// fingerprintjs library
import * as Fingerprint2 from 'fingerprintjs2'

// Store
import actions from './store/actions.js'
import getters from './store/getters.js'
import mutations from './store/mutations.js'
import state from './store/state.js'

Vue.use(Vuex)
Vue.use(VueCookies)
Vue.use(VueLazyload)
Vue.use(VueRouter)

// Vue.use(braintree)
// Vue.use(Vuelidate)
Vue.config.productionTip = false
Vue.config.devtools = true

// confirmed good mutators
const START_API_CALL = 'START_API_CALL'

const SAVE_ITEMS = 'SAVE_ITEMS'
const SAVE_LIST = 'SAVE_LIST'
const SAVE_TWO_FACTOR_PRIMARY_PHONE_NUMBER = 'SAVE_TWO_FACTOR_PRIMARY_PHONE_NUMBER'
const SAVE_API_RESPONSE = 'SAVE_API_RESPONSE'
const SAVE_AUTHENTICATION_STATE = 'SAVE_AUTHENTICATION_STATE'
const SAVE_TWO_FACTOR_STATE = 'SAVE_TWO_FACTOR_STATE'
const SAVE_IDENTITY = 'SAVE_IDENTITY'
const SAVE_CREDIT_CARDS = 'SAVE_CREDIT_CARDS'
const SAVE_REQUEST_QUOTE_INVENTORY_IDS = 'SAVE_REQUEST_QUOTE_INVENTORY_IDS'
const SAVE_LIVE_INVENTORY_ID = 'SAVE_LIVE_INVENTORYID'
const SAVE_CUSTOMER = 'SAVE_CUSTOMER'

const CLEAR_REQUEST_QUOTE_INVENTORY_IDS = 'CLEAR_REQUEST_QUOTE_INVENTORY_IDS'
const CLEAR_SHIPPING_ORDERS = 'CLEAR_SHIPPING_ORDERS'
const CLEAR_API_RESPONSE = 'CLEAR_API_RESPONSE'

const END_API_CALL = 'END_API_CALL'

const ADD_ITEM_TO_LIST = 'ADD_ITEM_TO_LIST'
const REMOVE_ITEM_FROM_LIST = 'REMOVE_ITEM_FROM_LIST'

const UPDATE_PAYING_INVOICE_IDS = 'UPDATE_PAYING_INVOICE_IDS'

// questionable mutators

const START_PROCESSING_BID = 'START_PROCESSING_BID'

const BID_SUCCESS = 'BID_SUCCESS'
const FINISH_PROCESSING_BID = 'FINISH_PROCESSING_BID'
const RECOGNIZE_BID = 'RECOGNIZE_BID'
const CANCEL_BID = 'CANCEL_BID'
const CLEAR_BID_STATE = 'CLEAR_BID_STATE'
const START_PHONE_BID = 'START_PHONE_BID'
const CANCEL_PHONE_BID = 'CANCEL_PHONE_BID'

// const REMOVE_FROM_LIST_SUCCESS = 'REMOVE_FROM_LIST_SUCCESS'

const CUSTOMER_BID_CARDS = 'CUSTOMER_BID_CARDS'
// const CUSTOMER_MAX_BIDS = 'CUSTOMER_MAX_BIDS'

const SHOW_MODAL = 'SHOW_MODAL'
const HIDE_MODAL = 'HIDE_MODAL'

const SAVE_PODIUM_STATE = 'SAVE_PODIUM_STATE'

// const ENABLE_LIVE_MODE = 'ENABLE_LIVE_MODE'
// const DISABLE_LIVE_MODE = 'DISABLE_LIVE_MODE'

const UPDATE_CUSTOMER_SMS_NUMBER = 'UPDATE_CUSTOMER_SMS_NUMBER'
const UPDATE_CUSTOMER_SMS_OUTBID = 'UPDATE_CUSTOMER_SMS_OUTBID'
const UPDATE_CUSTOMER_EMAIL_OUTBID = 'UPDATE_CUSTOMER_EMAIL_OUTBID'
const UPDATE_CUSTOMER_NOTIFICATIONS = 'UPDATE_CUSTOMER_NOTIFICATIONS'
const UPDATE_CUSTOMER_SHOW_TAX_EXEMPT_POPUP = 'UPDATE_CUSTOMER_SHOW_TAX_EXEMPT_POPUP'

// const SELL_LOT = 'SELL_LOT'
const UPDATE_WEBSITE_MESSAGE = 'UPDATE_WEBSITE_MESSAGE'
const SAVE_BIDDING_STATUSES = 'SAVE_BIDDING_STATUSES'
const SAVE_BIDDING_HISTORY = 'SAVE_BIDDING_HISTORY'
const SAVE_VIRTUAL_AUCTIONEER_MESSAGE = 'SAVE_VIRTUAL_AUCTIONEER_MESSAGE'
const SAVE_VIRTUAL_AUCTIONEER_CRASHED = 'SAVE_VIRTUAL_AUCTIONEER_CRASHED'

// const ADD_CARD_SUCCESS = 'ADD_CARD_SUCCESS'

const CREATE_ACCOUNT = 'CREATE_ACCOUNT'
const CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS'
const CREATE_ACCOUNT_ERROR = 'CREATE_ACCOUNT_ERROR'

const SAVE_INVOICE_DATA = 'SAVE_INVOICE_DATA'
const DELETE_INVOICE_DATA = 'DELETE_INVOICE_DATA'
const SAVE_SHIPPING_ORDER_DATA = 'SAVE_SHIPPING_ORDER_DATA'
const CLEAR_PAY_INVOICE_MODAL_ERROR = 'CLEAR_PAY_INVOICE_MODAL_ERROR'
const SHOW_PAY_INVOICE_CARD_FORM = 'SHOW_PAY_INVOICE_CARD_FORM'
const HIDE_PAY_INVOICE_CARD_FORM = 'HIDE_PAY_INVOICE_CARD_FORM'
const SET_ACTIVE_ACCOUNT_TAB = 'SET_ACTIVE_ACCOUNT_TAB'
const ACCOUNT_MENU_SHIFT_LEFT = 'ACCOUNT_MENU_SHIFT_LEFT'
const INSERT_ACCOUNT_HISTORY = 'INSERT_ACCOUNT_HISTORY'
const DELETE_ACCOUNT_HISTORY = 'DELETE_ACCOUNT_HISTORY'
const CLEAR_ALL_ACCOUNT_HISTORY = 'CLEAR_ALL_ACCOUNT_HISTORY'
const UPDATE_CURRENT_INVOICE = 'UPDATE_CURRENT_INVOICE'
const RESET_ACCOUNT_MENU = 'RESET_ACCOUNT_MENU'
const UPDATE_CURRENT_SHIPPING_ORDER = 'UPDATE_CURRENT_SHIPPING_ORDER'
// const SHIPMENT_ARRANGED = 'SHIPMENT_ARRANGED'
const SAVE_PICKUP_ITEMS = 'SAVE_PICKUP_ITEMS'
const SAVE_SERVICE_LOCATIONS = 'SAVE_SERVICE_LOCATIONS'
const SAVE_ARTA_SHIPPING_STATUS = 'SAVE_ARTA_SHIPPING_STATUS'
const RESET_ARTA_SHIPPING_STATUS = 'RESET_ARTA_SHIPPING_STATUS'

const SAVE_CHECKOUT_INVOICE_ID = 'SAVE_CHECKOUT_INVOICE_ID'

const SAVE_PHONE_LIST = 'SAVE_PHONE_LIST'

const UPDATE_CURRENT_TIMESTAMP = 'UPDATE_CURRENT_TIMESTAMP'

const UPDATE_SHIPPING_ADDRESS = 'UPDATE_SHIPPING_ADDRESS'
const UPDATE_QUOTE_CANDIDATES = 'UPDATE_QUOTE_CANDIDATES'

const SET_CREDIT_CARD_FORM_IS_OPEN_IN_BIDDING_AREA = 'SET_CREDIT_CARD_FORM_IS_OPEN_IN_BIDDING_AREA'

const SET_FAVORITES_CARD_PAGINATION_STATUS = 'SET_FAVORITES_CARD_PAGINATION_STATUS'
const SET_IS_LOADING_FAVORITES = 'SET_IS_LOADING_FAVORITES'
const SET_IS_LOADING_INVOICE = 'SET_IS_LOADING_INVOICE'
const SET_IS_LOADING_INVOICES = 'SET_IS_LOADING_INVOICES'
const SET_IS_VALIDATING_ADDRESS = 'SET_IS_VALIDATING_ADDRESS'
const SET_IS_LOADING_ARTA_REQUEST_QUOTES = 'SET_IS_LOADING_ARTA_REQUEST_QUOTES'
const SET_IS_LOADING_PICKUP_NO_SHIPPING = 'SET_IS_LOADING_PICKUP_NO_SHIPPING'
const SET_IS_LOADING_ACCOUNT = 'SET_IS_LOADING_ACCOUNT'

const UPDATE_PAYMENT_FORM = 'UPDATE_PAYMENT_FORM'

function llFormatCurrency(amount) {
	return amount.toString().replace(/\d(?=(\d{3})+$)/g, '$&,')
}

function llGetUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
	let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
	let results = regex.exec(location.search)
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

// the store object
const store = new Vuex.Store({
	/**
	 * State
	 */
	state: {
		...state,
		apiResponse: {},
		serviceLocations: {
			api: {
				path: ''
			},
			pusher_main: {
				channel: '',
				region: ''
			},
			pusher_virtual_auctioneer: {
				channel: '',
				region: ''
			}
		},
		customer: {
			bid_cards: {},
			max_bids: {},
			cc: {},
			phone_bids: {},
			two_factor_primary_phone_number: '',
			two_factor_secondary_phone_number: ''
		},
		isAuthenticated: false,
		twoFactorRequest: '',
		successfullyCreatedAccount: false,
		creditCardFormIsOpenInBiddingArea: false,
		apiPending: {},
		payInvoiceModalError: '',
		items: {},
		invoices: {},
		shippingOrders: {},
		currentInvoice: 0,
		currentShippingOrder: 0,
		pickupItems: [],
		phoneList: [],
		passwordlessLoginMessage: '',
		biddingStatuses: {},
		biddingHistories: {},
		lists: {},
		departments: {},
		stories: {},
		auctions: {},
		sessions: {},
		activeAccountTab: '',
		accountCardHistory: [],
		accountMenuShiftLeft: false,
		modal: {
			show: false,
			component: ''
		},
		currentLiveInventoryId: null,
		virtualAuctioneerStatus: {
			message: '',
			la_console_state: '',
			inv_console_state: ''
		},
		virtualAuctioneerCrashed: false,
		podium: {
			auction_url: '',
			inventoryId: '',
			lot_number: '',
			display_lotnumber: '',
			lead: '',
			image: '',
			url: null,
			consignor: '',
			description: '',
			size: '',
			estimate: '',
			auction_position: '',
			auction_status: '',
			current: {
				amount: null,
				bidcard: null,
				recognized: null,
				id: null,
				asking: null
			},
			upNext: {
				amount: null,
				bidcard: null,
				recognized: null,
				id: null,
				asking: null
			},
			upNow: {
				amount: null,
				bidcard: null,
				recognized: null,
				id: null,
				asking: null
			}
		},
		sortColumn: 'lotnumber',
		sortOrder: 1,
		payInvoiceModalIsCardFormVisible: false,
		websiteMessage: {
			content: ''
		},
		requestQuoteInventoryIds: [],
		hasServiceLocations: false,
		payingInvoiceIds: [],
		now: new Date() / 1000,
		checkoutInvoiceId: 0,
		shippingAddress: {
			street_1: '',
			street_2: '',
			street_3: '',
			city: '',
			state: '',
			zip: '',
			country: '',
			contacts: {
				name: '',
				email_address: '',
				phone_number: ''
			}
		},
		quoteCandidates: [],
		artaShippingStatus: [],
		paymentForm: {}
	},

	/**
	 * Mutators
	 */
	mutations: {
		...mutations,
		[START_API_CALL](state, payload) {
			Vue.set(state.apiPending, payload.postData.context, true)
		},

		[END_API_CALL](state, payload) {
			Vue.delete(state.apiPending, payload.postData.context)
		},

		[SAVE_API_RESPONSE](state, payload) {
			// an existing object for this api response's context does not exist in the store
			if (typeof state.apiResponse[payload.request.context] === 'undefined') {
				// create an object for this context in which we can dump the api response
				Vue.set(state.apiResponse, payload.request.context, {})
			}

			// store the api response
			Vue.set(state.apiResponse[payload.request.context], 'result', payload.response.result)
			Vue.set(state.apiResponse[payload.request.context], 'message_id', payload.response.message_id)
			Vue.set(state.apiResponse[payload.request.context], 'message', payload.response.message)
			Vue.set(state.apiResponse[payload.request.context], 'payload', payload.response.payload)
		},

		[CLEAR_API_RESPONSE](state, payload) {
			// the specified context in the payload has an existing object in the store
			if (typeof state.apiResponse[payload] !== 'undefined') {
				// delete the api response from the object for the given context
				Vue.delete(state.apiResponse, payload)
			}
		},

		[SAVE_AUTHENTICATION_STATE](state, payload) {
			Vue.set(state, 'isAuthenticated', payload.isAuthenticated)
			if (typeof payload.token !== 'undefined') {
				// set cookie for 2 weeks
				$cookies.set('llatoken', payload.token, 14 * 24 * 60 * 60)
			}
		},
		[SAVE_IDENTITY](state, payload) {
			if (typeof payload.identity !== 'undefined') {
				// set identity to expire in 10 years
				$cookies.set('fp_identity', payload.identity, 10 * 365 * 24 * 60 * 60)
			}
		},

		[SAVE_TWO_FACTOR_STATE](state, payload) {
			Vue.set(state, 'twoFactorRequest', payload.two_factor_token)
		},

		[SET_CREDIT_CARD_FORM_IS_OPEN_IN_BIDDING_AREA](state, payload) {
			Vue.set(
				state,
				'creditCardFormIsOpenInBiddingArea',
				payload.credit_card_form_is_open_in_bidding_area
			)
		},

		[SAVE_CUSTOMER](state, payload) {
			Vue.set(state, 'customer', payload)
		},

		[SAVE_TWO_FACTOR_PRIMARY_PHONE_NUMBER](state, payload) {
			Vue.set(state.customer, 'two_factor_primary_phone_number', payload)
		},

		[SAVE_CREDIT_CARDS](state, payload) {
			Vue.set(state, 'customerCreditCards', payload)
		},

		[SAVE_REQUEST_QUOTE_INVENTORY_IDS](state, payload) {
			Object.keys(payload).forEach(function (key) {
				Vue.set(state.requestQuoteInventoryIds, key, payload[key])
			})
		},

		[CLEAR_REQUEST_QUOTE_INVENTORY_IDS](state) {
			Vue.set(state, 'requestQuoteInventoryIds', [])
		},

		[CLEAR_SHIPPING_ORDERS](state) {
			Vue.set(state, 'shippingOrders', {})
		},

		[SAVE_LIVE_INVENTORY_ID](state, payload) {
			Vue.set(state, 'currentLiveInventoryId', payload)
		},

		[SAVE_LIST](state, payload) {
			Object.keys(payload).forEach(function (key) {
				// if the list does not exist in the store already
				// create the empty object for it
				if (typeof state.lists[key] === 'undefined') {
					Vue.set(state.lists, key, {})
				}

				Object.keys(payload[key]).forEach(function (pkey) {
					// store everything that comes back from the get list call
					// except the items
					if (pkey !== 'items') {
						Vue.set(state.lists[key], pkey, payload[key][pkey])
					}
				})
			})
		},

		// add an item to a list in the store
		[ADD_ITEM_TO_LIST](state, payload) {
			// the inventory id does not exist in the list
			if (
				!state.lists['LISTID_' + payload.list_id].inventory_ids.find(
					(inventoryId) => inventoryId === payload.inventory_id
				)
			) {
				// add the inventory id to the list
				state.lists['LISTID_' + payload.list_id].inventory_ids.unshift(payload.inventory_id)
			}
		},

		// remove an item from a list in the store
		[REMOVE_ITEM_FROM_LIST](state, payload) {
			// the inventory id exists in the list
			if (
				state.lists['LISTID_' + payload.list_id].inventory_ids.find(
					(inventoryId) => inventoryId === payload.inventory_id
				)
			) {
				// remove the inventory id from the list's inventory id array
				Vue.delete(
					state.lists['LISTID_' + payload.list_id].inventory_ids,
					state.lists['LISTID_' + payload.list_id].inventory_ids.findIndex(
						(inventoryId) => inventoryId === payload.inventory_id
					)
				)
			}
		},

		// call this mutation when a bid is successfully processed
		[BID_SUCCESS](state, payload) {
			// it is not a telephone bid
			if (!payload.request.telephone_bid) {
				// the customer has bid on this item previously
				if (payload.request.inventory_id in state.customer.max_bids) {
					// the customer's existing max bid on the item is less than or equal to the amount from this bid
					if (
						state.customer.max_bids[payload.request.inventory_id].bid_amount <=
						payload.request.bid_amount
					) {
						// update the customer's max bids to reflect this new amount
						Vue.set(
							state.customer.max_bids[payload.request.inventory_id],
							'bid_amount',
							payload.request.bid_amount
						)
						Vue.set(
							state.customer.max_bids[payload.request.inventory_id],
							'next_increment',
							payload.response.payload.next_increment
						)
					}

					// the customer has not previously bid on this item
				} else {
					// store the bid in the customer's max bids
					Vue.set(state.customer.max_bids, payload.request.inventory_id, {})
					Vue.set(
						state.customer.max_bids[payload.request.inventory_id],
						'bid_amount',
						payload.request.bid_amount
					)
					Vue.set(
						state.customer.max_bids[payload.request.inventory_id],
						'next_increment',
						payload.response.payload.next_increment
					)
				}

				// it is a telephone bid
			} else if (payload.request.telephone_bid === true) {
				// add the bid to the customer's phone bid
				Vue.set(state.customer.phone_bids, payload.request.inventory_id, {})
				Vue.set(
					state.customer.phone_bids[payload.request.inventory_id],
					'primaryphone',
					payload.request.primary_phone
				)
				Vue.set(
					state.customer.phone_bids[payload.request.inventory_id],
					'secondaryphone',
					payload.request.secondary_phone
				)
			}

			// add the bid card number they now have
			Vue.set(
				state.customer.bid_cards,
				payload.response.payload.auction_id,
				payload.response.payload.bidcard_number
			)

			// reset the values we need to reset
			Vue.set(state.biddingStatuses['ITEMID_' + payload.request.inventory_id], 'pending_bid', false)
			Vue.set(
				state.biddingStatuses['ITEMID_' + payload.request.inventory_id],
				'phone_bid_started',
				false
			)
		},

		[SAVE_VIRTUAL_AUCTIONEER_MESSAGE](state, payload) {
			if (typeof payload !== 'undefined') {
				// loop through all of the bidding statuses of items that were given to us
				Object.keys(payload).forEach(function (key) {
					Vue.set(state.virtualAuctioneerStatus, key, payload[key])
				})
			}
		},

		// save the bidding status of an item(s)
		[SAVE_BIDDING_STATUSES](state, payload) {
			// a payload was provided
			if (typeof payload !== 'undefined') {
				// loop through all of the bidding statuses of items that were given to us
				Object.keys(payload).forEach(function (key) {
					// this item exists in our state
					if (typeof state.biddingStatuses[key] !== 'undefined') {
						// the pending bid bidding status attribute for this item is true
						if (state.biddingStatuses[key].pending_bid === true) {
							// set our payload pending bid status to true
							payload[key]['pending_bid'] = true
						} else {
							payload[key]['pending_bid_amount'] = 0
						}

						// the item has not yet been saved to our state
					} else {
						// create an empty object for it in the store
						Vue.set(state.biddingStatuses, key, {})
					}

					// loop through the key value pairs for this bidding update and write to the store
					Object.keys(payload[key]).forEach(function (pkey) {
						Vue.set(state.biddingStatuses[key], pkey, payload[key][pkey])
					})
				})
			}
		},

		// save invoices to the store
		[SAVE_INVOICE_DATA](state, payload) {
			if (payload) {
				// loop through the payload
				Object.keys(payload).forEach(function (key) {
					// this particular invoice is not in the store
					if (typeof state.invoices[key] === 'undefined') {
						// add it to the store
						Vue.set(state.invoices, key, payload[key])

						// this invoice is already in the store
					} else {
						// loop through the attributes for this invoice object
						Object.keys(payload[key]).forEach(function (pkey) {
							// save this attribute for the invoice in the store
							Vue.set(state.invoices[key], pkey, payload[key][pkey])
						})
					}
				})
			}
		},

		[UPDATE_PAYING_INVOICE_IDS](state, payload) {
			state.payingInvoiceIds.splice(0, state.payingInvoiceIds.length)
			for (let i = 0; i < payload.length; i++) {
				state.payingInvoiceIds.push(payload[i])
			}
		},

		[UPDATE_SHIPPING_ADDRESS](state, payload) {
			for (var key in state.shippingAddress) {
				if (key === 'contacts') {
					for (var key2 in state.shippingAddress.contacts) {
						Vue.set(state.shippingAddress.contacts, key2, payload.contacts[key2])
					}
					continue
				}
				Vue.set(state.shippingAddress, key, payload[key])
			}
		},

		[UPDATE_QUOTE_CANDIDATES](state, payload) {
			var quoteFields = ['id', 'price', 'description', 'selected', 'isCustom', 'request']
			state.quoteCandidates.splice(0, state.quoteCandidates.length)
			for (let i = 0; i < payload.length; i++) {
				let quoteIn = payload[i]
				let quoteNew = {}
				for (let k = 0; k < quoteFields.length; k++) {
					let quoteField = quoteFields[k]
					quoteNew[quoteField] = quoteIn[quoteField]
				}
				state.quoteCandidates.push(quoteNew)
			}
		},
		[SAVE_ARTA_SHIPPING_STATUS](state, payload) {
			// Not sure if there is a great way to look up by an invoice Id, so will just assume only 1 at a time for now
			state.artaShippingStatus = []

			// Payload should be a ShipmentResponse model from API
			state.artaShippingStatus.push(payload)
		},
		[RESET_ARTA_SHIPPING_STATUS](state, payload) {
			state.artaShippingStatus = []
		},

		// in progress mutations

		[INSERT_ACCOUNT_HISTORY](state, payload) {
			state.accountCardHistory.unshift(payload)
		},
		[DELETE_ACCOUNT_HISTORY](state) {
			state.accountCardHistory.shift()
		},
		[CLEAR_ALL_ACCOUNT_HISTORY](state) {
			state.accountCardHistory = []
		},
		[ACCOUNT_MENU_SHIFT_LEFT](state, payload) {
			Vue.set(state, 'accountMenuShiftLeft', payload)
		},
		[SET_ACTIVE_ACCOUNT_TAB](state, payload) {
			Vue.set(state, 'activeAccountTab', payload)
		},
		[SET_CREDIT_CARD_FORM_IS_OPEN_IN_BIDDING_AREA](state, payload) {
			Vue.set(state, 'creditCardFormIsOpenInBiddingArea', payload)
		},
		[SET_FAVORITES_CARD_PAGINATION_STATUS](state, payload) {
			Vue.set(state, 'favoritesCardPaginationStatus', payload)
		},
		[SET_IS_LOADING_FAVORITES](state, payload) {
			Vue.set(state, 'favoritesIsLoading', payload)
		},
		[SET_IS_LOADING_INVOICE](state, payload) {
			Vue.set(state, 'invoiceIsLoading', payload)
		},
		[SET_IS_LOADING_INVOICES](state, payload) {
			Vue.set(state, 'invoicesIsLoading', payload)
		},
		[SET_IS_VALIDATING_ADDRESS](state, payload) {
			Vue.set(state, 'addressIsValidating', payload)
		},
		[SET_IS_LOADING_ARTA_REQUEST_QUOTES](state, payload) {
			Vue.set(state, 'artaRequestQuotesIsLoading', payload)
		},
		[SET_IS_LOADING_PICKUP_NO_SHIPPING](state, payload) {
			Vue.set(state, 'pickupNoShippingIsLoading', payload)
		},
		[SET_IS_LOADING_ACCOUNT](state, payload) {
			Vue.set(state, 'accountIsLoading', payload)
		},
		[CREATE_ACCOUNT](state) {
			Vue.set(state, 'createAccountModalIsAwaitingResponse', true)
			Vue.set(state, 'createAccountModalError', '')
		},
		[RESET_ACCOUNT_MENU](state) {
			Vue.set(state, 'createAccountModalError', '')
			Vue.set(state, 'successfullyCreatedAccount', false)
			Vue.set(state, 'accountCardHistory', [])
		},
		[CREATE_ACCOUNT_SUCCESS](state, payload) {
			if (payload.result === 'success') {
				Vue.set(state, 'successfullyCreatedAccount', true)
			}
			Vue.set(state, 'createAccountModalIsAwaitingResponse', false)
			Vue.set(state, 'createAccountModalError', payload.message)
		},
		[CREATE_ACCOUNT_ERROR](state, payload) {
			Vue.set(state, 'createAccountModalIsAwaitingResponse', false)
			Vue.set(state, 'createAccountModalError', payload)
		},
		[START_PHONE_BID](state, payload) {
			if (payload.telephone_bid) {
				Vue.set(state.biddingStatuses['ITEMID_' + payload.inventory_id], 'phone_bid_started', true)
			}
		},
		[CANCEL_PHONE_BID](state, payload) {
			Vue.set(state.biddingStatuses['ITEMID_' + payload.inventory_id], 'phone_bid_started', false)
		},
		[SHOW_PAY_INVOICE_CARD_FORM](state) {
			Vue.set(state, 'payInvoiceModalIsCardFormVisible', true)
		},
		[HIDE_PAY_INVOICE_CARD_FORM](state) {
			Vue.set(state, 'payInvoiceModalIsCardFormVisible', false)
		},
		[CLEAR_PAY_INVOICE_MODAL_ERROR](state) {
			Vue.set(state, 'payInvoiceModalError', '')
		},

		[START_PROCESSING_BID](state, payload) {
			Vue.set(state.biddingStatuses['ITEMID_' + payload.inventory_id], 'pending_bid', true)
		},

		[FINISH_PROCESSING_BID](state, payload) {
			Vue.set(state.biddingStatuses['ITEMID_' + payload.inventory_id], 'pending_bid', false)
		},

		[CANCEL_BID](state) {},
		[CLEAR_BID_STATE](state) {},
		[CUSTOMER_BID_CARDS](state) {},
		[HIDE_MODAL](state) {
			Vue.set(state, 'successfullyCreatedAccount', false)
			Vue.set(state, 'currentInvoice', 0)
			Vue.set(state.modal, 'show', false)
			Vue.set(state.modal, 'component', '')
		},
		[SHOW_MODAL](state, payload) {
			Vue.set(state.modal, 'show', true)
			Vue.set(state.modal, 'component', payload.component)
			Vue.set(state.modal, 'props', payload.props)
		},
		[RECOGNIZE_BID](state, payload) {
			if (!payload.hasUpNext) {
				Vue.set(state.podium['current'], 'recognized', 'y')
				Vue.set(state.podium['upNow'], 'amount', null)
				Vue.set(state.podium['upNow'], 'recognized', null)
				Vue.set(state.podium['upNow'], 'id', null)
				Vue.set(state.podium['upNow'], 'asking', null)
			} else {
				copyUpNow(function () {
					copyUpNext(function () {
						clearUpNext(function () {
							// done
						})
					})
				})

				function copyUpNow(callback) {
					Vue.set(state.podium['current'], 'amount', state.podium['upNow']['amount'])
					Vue.set(state.podium['current'], 'bidcard', state.podium['upNow']['bidcard'])
					Vue.set(state.podium['current'], 'recognized', true)
					Vue.set(state.podium['current'], 'id', state.podium['upNow']['id'])
					Vue.set(state.podium['current'], 'asking', state.podium['upNow']['asking'])
					callback()
				}

				function copyUpNext(callback) {
					Vue.set(state.podium['upNow'], 'amount', state.podium['upNext']['amount'])
					Vue.set(state.podium['upNow'], 'bidcard', state.podium['upNext']['bidcard'])
					Vue.set(state.podium['upNow'], 'recognized', state.podium['upNext']['recognized'])
					Vue.set(state.podium['upNow'], 'id', state.podium['upNext']['id'])
					Vue.set(state.podium['upNow'], 'asking', state.podium['upNext']['asking'])
					callback()
				}

				function clearUpNext(callback) {
					Vue.set(state.podium['upNext'], 'amount', null)
					Vue.set(state.podium['upNext'], 'bidcard', null)
					Vue.set(state.podium['upNext'], 'recognized', null)
					Vue.set(state.podium['upNext'], 'id', null)
					Vue.set(state.podium['upNext'], 'asking', null)
					callback()
				}
			}
		},
		[SAVE_PODIUM_STATE](state, payload) {
			if (
				payload.current_live_lot &&
				payload.auction_url &&
				state.podium.auction_url !== payload.auction_url
			) {
				// Set the auction_url on the podium
				Vue.set(state.podium, 'auction_url', payload.auction_url)
			}
			// use the state.currentLiveInventoryId to recreate the state.podium with
			// data from the state.items and state,biddingStatuses

			// advance to the next lot if the current
			if (state.podium.inventoryId !== payload.inventory_id) {
				// set the current, upNow and upNext fields for bids
				Vue.set(state.podium['current'], 'amount', null)
				Vue.set(state.podium['current'], 'bidcard', null)
				Vue.set(state.podium['current'], 'recognized', null)
				Vue.set(state.podium['current'], 'id', null)
				Vue.set(state.podium['current'], 'asking', null)

				Vue.set(state.podium['upNow'], 'amount', null)
				Vue.set(state.podium['upNow'], 'bidcard', null)
				Vue.set(state.podium['upNow'], 'recognized', null)
				Vue.set(state.podium['upNow'], 'id', null)
				Vue.set(state.podium['upNow'], 'asking', null)

				Vue.set(state.podium['upNext'], 'amount', null)
				Vue.set(state.podium['upNext'], 'bidcard', null)
				Vue.set(state.podium['upNext'], 'recognized', null)
				Vue.set(state.podium['upNext'], 'id', null)
				Vue.set(state.podium['upNext'], 'asking', null)
			}

			Vue.set(state.podium['current'], 'asking', payload.current_asking_bid)

			// typeof (payload.current_high_bid_recognized) !== 'undefined' &&
			if (payload.current_high_bid_recognized) {
				Vue.set(state.podium['current'], 'amount', payload.current_high_bid_amount)
				Vue.set(state.podium['current'], 'bidcard', payload.current_high_bidcard)
				Vue.set(state.podium['current'], 'recognized', payload.current_high_bid_recognized)
				Vue.set(state.podium['current'], 'id', payload.current_high_bid_id)
				Vue.set(state.podium['current'], 'asking', payload.current_asking_bid)

				if (state.podium['upNow']['amount'] <= state.podium['current']['amount']) {
					copyUpNext(function () {
						Vue.set(state.podium['upNext'], 'amount', null)
						Vue.set(state.podium['upNext'], 'bidcard', null)
						Vue.set(state.podium['upNext'], 'recognized', null)
						Vue.set(state.podium['upNext'], 'id', null)
						Vue.set(state.podium['upNext'], 'asking', null)
					})
					function copyUpNext(callback) {
						Vue.set(state.podium['upNow'], 'amount', state.podium['upNext']['amount'])
						Vue.set(state.podium['upNow'], 'bidcard', state.podium['upNext']['bidcard'])
						Vue.set(state.podium['upNow'], 'recognized', state.podium['upNext']['recognized'])
						Vue.set(state.podium['upNow'], 'id', state.podium['upNext']['id'])
						Vue.set(state.podium['upNow'], 'asking', state.podium['upNext']['asking'])
						callback()
					}
				}
			} else {
				if (state.podium['upNow']['amount'] === null) {
					Vue.set(state.podium['upNow'], 'amount', payload.current_high_bid_amount)
					Vue.set(state.podium['upNow'], 'bidcard', payload.current_high_bidcard)
					Vue.set(state.podium['upNow'], 'recognized', payload.current_high_bid_recognized)
					Vue.set(state.podium['upNow'], 'id', payload.current_high_bid_id)
					Vue.set(state.podium['upNow'], 'asking', payload.current_asking_bid)
				}
				if (
					state.podium['upNow']['id'] !== payload.current_high_bid_id &&
					payload.current_high_bid_amount > state.podium['upNow']['amount']
				) {
					Vue.set(state.podium['upNext'], 'amount', payload.current_high_bid_amount)
					Vue.set(state.podium['upNext'], 'bidcard', payload.current_high_bidcard)
					Vue.set(state.podium['upNext'], 'recognized', payload.current_high_bid_recognized)
					Vue.set(state.podium['upNext'], 'id', payload.current_high_bid_id)
					Vue.set(state.podium['upNext'], 'asking', payload.current_asking_bid)
				}
			}
		},
		[UPDATE_WEBSITE_MESSAGE](state, payload) {
			Vue.set(state.websiteMessage, 'level', payload.level)
			Vue.set(state.websiteMessage, 'content', payload.content)
		},

		// save items to the store
		[SAVE_ITEMS](state, payload) {
			// the payload must something
			if (typeof payload !== 'undefined') {
				// for each of the items in the payload
				Object.keys(payload).forEach(function (key) {
					// the item does not already exist in the store
					if (typeof state.items[key] === 'undefined') {
						// write the entire item object to the store
						Vue.set(state.items, key, payload[key])

						// the item already exists in the store
					} else {
						// for each of the item's attributes
						Object.keys(payload[key]).forEach(function (pkey) {
							// write it over the existing attribute value for this item
							Vue.set(state.items[key], pkey, payload[key][pkey])
						})
					}
				})
			}
		},
		[SAVE_SERVICE_LOCATIONS](state, payload) {
			if (
				payload.api.path.length > 0 &&
				payload.pusher_main.channel.length > 0 &&
				payload.pusher_main.region.length > 0 &&
				payload.pusher_virtual_auctioneer.channel.length > 0 &&
				payload.pusher_virtual_auctioneer.region.length > 0
			) {
				Vue.set(state.serviceLocations.api, 'path', payload.api.path)
				Vue.set(state.serviceLocations.pusher_main, 'channel', payload.pusher_main.channel)
				Vue.set(state.serviceLocations.pusher_main, 'region', payload.pusher_main.region)
				Vue.set(
					state.serviceLocations.pusher_virtual_auctioneer,
					'channel',
					payload.pusher_virtual_auctioneer.channel
				)
				Vue.set(
					state.serviceLocations.pusher_virtual_auctioneer,
					'region',
					payload.pusher_virtual_auctioneer.region
				)
				Vue.set(state, 'hasServiceLocations', true)
			} else {
				Vue.set(state, 'hasServiceLocations', false)
			}
		},
		[SAVE_SHIPPING_ORDER_DATA](state, payload) {
			Object.keys(payload).forEach(function (key) {
				if (typeof state.shippingOrders[key] === 'undefined') {
					Vue.set(state.shippingOrders, key, payload[key])
					return
				}
				Object.keys(payload[key]).forEach(function (pkey) {
					Vue.set(state.shippingOrders[key], pkey, payload[key][pkey])
				})
			})
		},
		[SAVE_BIDDING_HISTORY](state, payload) {
			if (typeof payload !== 'undefined') {
				Object.keys(payload).forEach(function (key) {
					if (typeof state.biddingHistories[key] === 'undefined') {
						Vue.set(
							state.biddingHistories,
							'ITEMID_' + payload[key]['inventory_id'],
							payload[key]['bidding_history']
						)
					} else {
						let pos = Object.keys(state.biddingHistories[key]).length
						Object.keys(payload[key]['bidding_history']).forEach(function (pkey) {
							Vue.set(
								state.biddingHistories['ITEMID_' + payload[key]['inventory_id']],
								pos,
								payload[key]['bidding_history'][pkey]
							)
							pos = pos + 1
						})
					}
				})
			}
		},
		[UPDATE_CUSTOMER_NOTIFICATIONS](state, payload) {
			store.dispatch('updateCustomerNotifications', payload)
		},
		[UPDATE_CUSTOMER_SMS_NUMBER](state, payload) {
			Vue.set(state.customer, 'sms_number', payload)
		},
		[UPDATE_CUSTOMER_SMS_OUTBID](state, payload) {
			Vue.set(state.customer, 'sms_outbid', payload)
		},
		[UPDATE_CUSTOMER_EMAIL_OUTBID](state, payload) {
			Vue.set(state.customer, 'email_outbid', payload)
		},
		[UPDATE_CUSTOMER_SHOW_TAX_EXEMPT_POPUP](state, payload) {
			Vue.set(state.customer, 'show_tax_exempt_popup', payload)
		},
		[UPDATE_CURRENT_INVOICE](state, payload) {
			Vue.set(state, 'currentInvoice', payload)
		},
		[UPDATE_CURRENT_SHIPPING_ORDER](state, payload) {
			Vue.set(state, 'currentShippingOrder', payload)
		},
		[SAVE_PICKUP_ITEMS](state, payload) {
			Vue.set(state, 'pickupItems', payload)
			store.dispatch('insertAccountHistory', 'Pick Up')
		},
		[SAVE_PHONE_LIST](state, payload) {
			Vue.set(state, 'phoneList', payload)
		},
		[UPDATE_CURRENT_TIMESTAMP](state) {
			Vue.set(state, 'now', Math.floor(new Date() / 1000))
		},
		[SAVE_CHECKOUT_INVOICE_ID](state, payload) {
			Vue.set(state, 'checkoutInvoiceId', payload)
		},
		[UPDATE_PAYMENT_FORM](state, payload) {
			Vue.set(state, 'paymentForm', payload)
		},
		[SAVE_VIRTUAL_AUCTIONEER_CRASHED](state, payload) {
			Vue.set(state, 'virtualAuctioneerCrashed', payload)
		}
	},

	/**
	 * Getters
	 */
	getters: {
		...getters,
		paymentForm: (state) => {
			return state.paymentForm
		},
		artaShippingStatus: (state) => {
			return state.artaShippingStatus
		},
		// quote candidates are quotes retrieved from Arta for possible selection
		quoteCandidates: (state) => {
			let out = []
			var quoteFields = ['id', 'price', 'description', 'selected', 'isCustom', 'request']
			for (let i = 0; i < state.quoteCandidates.length; i++) {
				let quoteState = state.quoteCandidates[i]
				let quoteOut = {}
				for (let k = 0; k < quoteFields.length; k++) {
					let quoteField = quoteFields[k]
					quoteOut[quoteField] = quoteState[quoteField]
				}
				out.push(quoteOut)
			}
			return out
		},

		shippingAddress: (state) => {
			let out = {}
			for (var field in state.shippingAddress) {
				if (field === 'contacts') {
					out.contacts = {}
					for (var field2 in state.shippingAddress.contacts) {
						out.contacts[field2] = state.shippingAddress.contacts[field2]
					}
					continue
				}
				out[field] = state.shippingAddress[field]
			}
			return out
		},

		payingInvoiceIds: (state) => {
			let out = []
			for (let i = 0; i < state.payingInvoiceIds.length; i++) {
				out.push(state.payingInvoiceIds[i])
			}
			return out
		},

		entireState: (state) => {
			return state
		},

		now: (state) => {
			return state.now
		},

		customer: (state) => {
			return state.customer
		},

		customerCreditCards: (state) => {
			return state.customer.cc
		},

		customerBidCards: (state) => {
			return state.customer.bid_cards
		},

		customerPhoneBids: (state) => (inventoryId) => {
			return state.customer.phone_bids[inventoryId]
		},

		virtualAuctioneerStatus: (state) => {
			return state.virtualAuctioneerStatus
		},

		// returns the requested item from the store
		item: (state) => (inventoryId) => {
			if (typeof state.items['ITEMID_' + inventoryId] !== 'undefined') {
				return state.items['ITEMID_' + inventoryId]
			}
			return null
		},

		// tells us if we are the current high bidder on the provided inventory id
		itemIsCurrentHighBidder: (state, getters) => (inventoryId) => {
			// the item's bidding status exists in the store
			if (typeof getters.itemBiddingStatus(inventoryId) !== 'undefined') {
				// we have a bid card for the auction in which this item is being sold
				if (
					typeof state.customer.bid_cards[getters.itemBiddingStatus(inventoryId).auction_id] !==
					'undefined'
				) {
					// the item's current high bid card is this customer's bid card
					if (
						getters.itemBiddingStatus(inventoryId).current_high_bidcard ===
						state.customer.bid_cards[getters.itemBiddingStatus(inventoryId).auction_id]
					) {
						// they are the current high bidder
						return true
					}
				}
			}

			// they are not the current high bidder
			return false
		},

		// has the customer agreed to terms for the auction?
		itemWaitingForAgreement: (state, getters) => (inventoryId) => {
			// there is an api response for the place_bid context
			if (typeof getters.apiResponse.place_bid !== 'undefined') {
				// confirmation of the bid is required
				if (getters.apiResponse.place_bid.message_id === 'REQUIRES_AGREEMENT_TO_TERMS') {
					// we are waiting for the customer to agree to auction terms
					return true
				}
			}

			// we are not waiting for the customer to agree to auction terms
			return false
		},

		// does the customer have a card on file?
		itemRequiresCard: (state, getters) => (inventoryId) => {
			// there is an api response for the place_bid context
			if (typeof getters.apiResponse.place_bid !== 'undefined') {
				// having a valid card on file is required
				if (getters.apiResponse.place_bid.message_id === 'REQUIRES_CREDIT_CARD') {
					// we are waiting for the customer to add a credit card
					return true
				}
			}

			// we are not waiting for the customer to add a credit card
			return false
		},

		// are we waiting for the customer to confirm their bid?
		itemWaitingForConfirmation: (state, getters) => (inventoryId) => {
			// there is an api response for the place_bid context
			if (typeof getters.apiResponse.place_bid !== 'undefined') {
				// confirmation of the bid is required
				if (getters.apiResponse.place_bid.message_id === 'REQUIRES_AMOUNT_CONFIRMATION') {
					// we are waiting for the customer to confirm their bid
					return true
				}
			}

			// we are not waiting for the customer to confirm their bid
			return false
		},

		// are we waiting for the customer to confirm their bid?
		itemIsTelephoneBid: (state, getters) => (inventoryId) => {
			// there is an api response for the place_bid context
			if (
				typeof getters.apiResponse.place_bid !== 'undefined' &&
				typeof getters.apiResponse.place_bid.payload !== 'undefined' &&
				typeof getters.apiResponse.place_bid.payload.is_telephone_bid !== 'undefined'
			) {
				// confirmation of the bid is required
				if (getters.apiResponse.place_bid.payload.is_telephone_bid === true) {
					// we are waiting on a telephone bid confirmation
					return true
				}
			}

			// we are not waiting for the customer to confirm their bid
			return false
		},

		// the place bid adjusted amount
		placeBidAdjustedAmount: (state, getters) => {
			// there is a place bid api response
			if (typeof getters.apiResponse.place_bid !== 'undefined') {
				// there is an adjusted bid
				if (typeof getters.apiResponse.place_bid.payload.adjustedAmount !== 'undefined') {
					// return the adjusted bid
					return getters.apiResponse.place_bid.payload.adjustedAmount
				}
			}

			return false
		},

		// get the computed bid amount for an item, taking into account customer max bids
		itemBidButtonAmount: (state, getters) => (inventoryId) => {
			// there is an api response
			if (typeof getters.apiResponse.place_bid !== 'undefined') {
				// there is an adjusted amount in the api response
				if (typeof getters.apiResponse.place_bid.payload.adjustedAmount !== 'undefined') {
					// the bid button amount should be adjusted amount from the api
					return getters.apiResponse.place_bid.payload.adjustedAmount
				}
			}

			// the customer has a max bid and we have the item's bidding status
			if (getters.customerMaxBid(inventoryId).next_increment !== null) {
				// the next increment above the customer's max bid is greater than the current asking bid
				if (
					getters.customerMaxBid(inventoryId).next_increment >
					getters.itemBiddingStatus(inventoryId).current_asking_bid
				) {
					// the bid button amount should be the next increment above the customer's max bid
					return getters.customerMaxBid(inventoryId).next_increment

					// the next increment above the customer's max bid is not greater than the current asking bid
				} else {
					// the bid button amount should be the current asking bid
					return getters.itemBiddingStatus(inventoryId).current_asking_bid
				}

				// the customer does not have a max bid, and we do have the item's bidding status
			}

			// the bid button amount should be the current asking bid
			return getters.itemBiddingStatus(inventoryId).current_asking_bid
		},

		// get the bid button text for an item
		itemBidButtonText: (state, getters) => (inventoryId) => {
			// there is an api response for the place_bid context
			if (typeof getters.apiResponse.place_bid !== 'undefined') {
				// a bid amount is required
				if (getters.apiResponse.place_bid.message_id === 'REQUIRES_BID_AMOUNT') {
					return 'Place Bid'
				}

				// agreement to the terms is required
				if (getters.apiResponse.place_bid.message_id === 'REQUIRES_AGREEMENT_TO_TERMS') {
					return 'I Agree'
				}

				// a credit card is required
				if (getters.apiResponse.place_bid.message_id === 'REQUIRES_CREDIT_CARD') {
					return 'Add Card'
				}

				// confirmation of the bid is required
				if (getters.apiResponse.place_bid.message_id === 'REQUIRES_AMOUNT_CONFIRMATION') {
					return 'Confirm & Place Bid'
				}

				// there is not an api response for the place bid context
			} else {
				// the item has sold
				if (getters.itemBiddingStatus(inventoryId).has_sold) {
					return 'Sold'
				}

				// bidding is open
				if (getters.itemBiddingStatus(inventoryId).is_bidding_open) {
					// there is a pending bid
					if (getters.itemBiddingStatus(inventoryId).pending_bid) {
						return 'Bidding'

						// there is not a pending bid
					} else {
						return 'Bid Now'
					}

					// bidding is closed
				} else {
					// we are the high bidder
					if (getters.itemIsCurrentHighBidder(inventoryId)) {
						return 'Bid Now'

						// we are not the high bidder
					} else {
						return 'Closed'
					}
				}
			}

			// return an empty string
			return 'Bid Now'
		},

		phoneBidButtonText: (state, getters) => (inventoryId) => {
			// there is an api response for the place_bid context
			if (typeof getters.apiResponse.place_bid !== 'undefined') {
				// a bid amount is required
				if (getters.apiResponse.place_bid.message_id === 'REQUIRES_PRIMARY_PHONE') {
					return 'Request Telephone Bid'
				}

				// agreement to the terms is required
				if (getters.apiResponse.place_bid.message_id === 'REQUIRES_AGREEMENT_TO_TERMS') {
					return 'I Agree'
				}

				// a credit card is required
				if (getters.apiResponse.place_bid.message_id === 'REQUIRES_CREDIT_CARD') {
					return 'Add Card'
				}

				// confirmation of the bid is required
				if (getters.apiResponse.place_bid.message_id === 'REQUIRES_AMOUNT_CONFIRMATION') {
					return 'Confirm & Place Bid'
				}

				// there is not an api response for the place bid context
			} else {
				// the item has sold
				if (getters.itemBiddingStatus(inventoryId).has_sold) {
					return 'Sold'
				}

				// bidding is open
				if (getters.itemBiddingStatus(inventoryId).is_bidding_open) {
					// there is a pending bid
					if (getters.itemBiddingStatus(inventoryId).pending_bid) {
						return 'Bidding'

						// there is not a pending bid
					} else {
						return 'Request Telephone Bid'
					}

					// bidding is closed
				} else {
					// we are the high bidder
					if (getters.itemIsCurrentHighBidder(inventoryId)) {
						return 'Request Telephone Bid'

						// we are not the high bidder
					} else {
						return 'Closed'
					}
				}
			}

			// return an empty string
			return 'Request Telephone Bid'
		},

		// check to see if the customer has a pending bid on an item
		itemHasPendingBid: (state, getters) => (inventoryId) => {
			// the customer is the current high bidder and the current high bid is not recognized
			// or, the bidding status for the item tell us it has a pending bid
			if (
				(getters.itemIsCurrentHighBidder(inventoryId) &&
					getters.itemBiddingStatus(inventoryId).current_high_bid_recognized === 'n') ||
				getters.itemBiddingStatus(inventoryId).pending_bid === true
			) {
				// the item has a pending bid
				return true
			}

			// the item does not have a pending bid
			return false
		},

		/**
		 * Provides the auction status for the podium.
		 * @param {*} state
		 * @param {*} getters
		 * @returns string
		 */
		auctionStatus: (state, getters) => (inventoryId) => {
			// podium will have auction status from pusher updates.
			// if it doesn't yet, the item will have its auction status.
			if (state.podium.auction_status !== '') {
				return state.podium.auction_status
			}
			if (!inventoryId) {
				inventoryId = state.currentLiveInventoryId
			}
			return getters.itemBiddingStatus(inventoryId).auction_status
		},

		biddingStatuses: (state) => {
			return state.biddingStatuses
		},

		// get the bidding status for an item
		itemBiddingStatus: (getters) => (inventoryId) => {
			// we do not have a bidding status for the requested item
			if (typeof getters.biddingStatuses['ITEMID_' + inventoryId] === 'undefined') {
				// return an empty placeholder
				return {
					auction_id: '',
					auction_position: 0,
					auction_status: '',
					use_virtual_auctioneer: true,
					bidding_end_date: '',
					clerked_amount: '',
					current_asking_bid: '',
					current_high_bid_amount: '',
					current_high_bid_recognized: '',
					current_high_bidcard: '',
					current_live_lot: false,
					display_bid_count: '',
					has_passed: false,
					has_sold: false,
					is_bidding_open: null,
					is_telephone_bidding_open: false,
					pending_bid: false,
					phone_bid_started: false,
					seconds_remaining: 0
				}

				// we do have a bidding status in the store
			} else {
				// return the bidding status for the item
				return getters.biddingStatuses['ITEMID_' + inventoryId]
			}
		},

		// get a customer's max bid on an item
		customerMaxBid: (state) => (inventoryId) => {
			// we have the customer's max bids
			if (typeof state.customer.max_bids !== 'undefined') {
				// there is a max bid on the requested item
				if (typeof state.customer.max_bids[inventoryId] !== 'undefined') {
					// return that max bid for the customer
					return state.customer.max_bids[inventoryId]
				}
			}

			return { bid_amount: null, next_increment: null }
		},

		// tells us if we have a telephone bid on an item
		itemHasTelephoneBid: (state) => (inventoryId) => {
			// we have the customer's phone bids
			if (typeof state.customer.phone_bids !== 'undefined') {
				// there is a phone bid on the requested item
				if (typeof state.customer.phone_bids['ITEMID_' + inventoryId] !== 'undefined') {
					// we have a phone bid for this item
					return true
				}

				// we do not have the customer's phone bids, or we have their phone bids and
				// they have not placed a phone bid on this item
			} else {
				return false
			}
		},

		// get the computed sold status for an item
		itemSoldStatus: (state, getters) => (inventoryId) => {
			if (getters.item(inventoryId) && getters.item(inventoryId).category_name === 'Real Estate') {
				if (
					getters.itemBiddingStatus(inventoryId).has_passed === true ||
					getters.itemBiddingStatus(inventoryId).has_sold === true
				) {
					return 'The Auction has ended'
				}
			}

			// the item has passed
			if (getters.itemBiddingStatus(inventoryId).has_passed === true) {
				if (getters.itemBiddingStatus(inventoryId).has_reserve) {
					return 'Not sold, reserve not met.'
				}
				return 'Not Sold'
			}

			// the item has sold
			if (getters.itemBiddingStatus(inventoryId).has_sold === true) {
				return 'Sold $' + llFormatCurrency(getters.itemBiddingStatus(inventoryId).clerked_amount)
			}

			// bidding is open and bids have been placed
			if (
				getters.itemBiddingStatus(inventoryId).is_bidding_open &&
				getters.itemBiddingStatus(inventoryId).display_bid_count.length > 0
			) {
				return (
					'Asking $' +
					llFormatCurrency(getters.itemBiddingStatus(inventoryId).current_asking_bid) +
					'&nbsp;&middot;&nbsp;' +
					getters.itemBiddingStatus(inventoryId).display_bid_count
				)
			}

			// bidding is open and there are not bids
			if (
				getters.itemBiddingStatus(inventoryId).is_bidding_open &&
				getters.itemBiddingStatus(inventoryId).display_bid_count.length === 0
			) {
				return (
					'Asking $' + llFormatCurrency(getters.itemBiddingStatus(inventoryId).current_asking_bid)
				)
			}

			// return an empty status by default
			return ''
		},

		/**
		 * Get the computed bidding message for an item.
		 * @param {*} state
		 * @param {*} getters
		 * @returns object
		 */
		itemBiddingMessage: (state, getters) => (inventoryId, viewType) => {
			// We do not have the bidding status for this item
			if (typeof getters.itemBiddingStatus(inventoryId) === 'undefined') {
				// return an empty object
				return {
					severity: '',
					message: ''
				}
			}
			// We do have the bidding status for the item

			// The auction is paused
			if (getters.podium.auction_status === 'paused') {
				// return the failure message
				return {
					severity: 'error',
					message: 'The auction is paused and will resume momentarily.'
				}
			}

			// There is an active bid
			if (typeof getters.apiResponse.place_bid !== 'undefined') {
				// there is a failure
				if (getters.apiResponse.place_bid.result === 'failure') {
					// return the failure message
					return {
						severity: 'error',
						message: getters.apiResponse.place_bid.message
					}
				}
			}

			// The item has passed
			if (getters.itemBiddingStatus(inventoryId).has_passed === true) {
				return {
					severity: '',
					message: ''
				}
			}

			// We are authenticated
			if (getters.isAuthenticated) {
				// the customer does not have a bid card in the item's auction
				if (!(getters.itemBiddingStatus(inventoryId).auction_id in state.customer.bid_cards)) {
					// the item has sold or passed
					if (
						getters.itemBiddingStatus(inventoryId).has_sold ||
						getters.itemBiddingStatus(inventoryId).has_passed
					) {
						// the item has sold or passed and they did not have a bid card for the
						// auction in which this item is selling, meaning they haven't placed a bid on it
						// so just show them nothing
						return {
							severity: '',
							message: ''
						}

						// the customer does not have a bid pending on the item
					} else if (!getters.itemBiddingStatus(inventoryId).pending_bid) {
						//
						//
						// list view return here blank severity and message
						//
						//
						if (viewType === 'list' || viewType === 'condensed_list') {
							return {
								severity: '',
								message: ''
							}
						}

						//
						// (item_view return here)
						//
						// this item has not sold or passed, so bidding is open and the customer
						// does not have a bid pending on the item, so they haven't placed a bid
						// so tell them they have not placed a bid
						//
						return {
							severity: 'default',
							message: 'You have not placed a bid.'
						}
					}

					// the customer does have a bid card for this auction
				} else {
					// the customer's bid card is the current high bid card for this item
					if (
						getters.itemBiddingStatus(inventoryId).current_high_bidcard ===
						state.customer.bid_cards[getters.itemBiddingStatus(inventoryId).auction_id]
					) {
						// the current high bid for this item is recognized and the customer
						// does not have a pending bid on the item
						if (
							getters.itemBiddingStatus(inventoryId).current_high_bid_recognized &&
							!getters.itemBiddingStatus(inventoryId).pending_bid
						) {
							// the item has sold
							if (getters.itemBiddingStatus(inventoryId).has_sold) {
								//
								//
								// output for list view goes here
								//
								//
								if (viewType === 'list' || viewType === 'condensed_list') {
									return {
										severity: 'success',
										message: 'Winning Bidder'
									}
								}

								// the customer has a bid card for this auction and their bid card
								// is the same as the current high bid card for the item, and the item has
								// sold, so tell them they are the winning bidder.
								return {
									severity: 'success',
									message: 'You are the winning bidder.'
								}

								// the item has not sold
							} else {
								//
								//
								// output for list view goes here
								//
								//
								if (viewType === 'list' || viewType === 'condensed_list') {
									return {
										severity: 'success',
										message: 'High Bidder'
									}
								}

								let tempBidAmount = state.customer.max_bids[inventoryId].bid_amount

								// Make sure bid_amount is actually a number and not a string like this '1,250'
								if (
									!Number.isFinite(tempBidAmount) &&
									tempBidAmount !== null &&
									tempBidAmount !== undefined
								) {
									tempBidAmount = tempBidAmount.replace(/,/g, '')
									tempBidAmount = parseInt(tempBidAmount, 10)
								}

								// the current high bid is less that this customer's max bid for the item
								if (
									getters.itemBiddingStatus(inventoryId).current_high_bid_amount < tempBidAmount
								) {
									// the customer has a bid card for the auction, they are the current high
									// bidder, the item has not yet sold and the customer's max bid on the
									// item is greater than the current high bid amount, tell them they are
									// the high bidder and where the bid is at and what their max bid is.
									return {
										severity: 'success',
										message:
											'You are the current high bidder at $' +
											llFormatCurrency(
												getters.itemBiddingStatus(inventoryId).current_high_bid_amount
											) +
											', with a maximum bid of $' +
											llFormatCurrency(state.customer.max_bids[inventoryId].bid_amount) +
											'.'
									}

									// the current high bid is not less than this customer's max bid for the item
								} else {
									// the customer has a bid card for this auction, they are the current
									// high bidder, the item has not sold and the current high bid for the
									// item is not greater than their max bid on the item, so tell them
									// they are the high bidder at the current high bid amount.
									return {
										severity: 'success',
										message:
											'You are the current high bidder at $' +
											llFormatCurrency(
												getters.itemBiddingStatus(inventoryId).current_high_bid_amount
											) +
											'.'
									}
								}
							}

							// the current high bid for this item is not recognized, or the customer
							// has a pending bid on the item
						} else {
							// the item has sold
							if (getters.itemBiddingStatus(inventoryId).has_sold) {
								//
								//
								// output for list view goes here
								//
								//
								if (viewType === 'list' || viewType === 'condensed_list') {
									return {
										severity: 'error',
										message: 'Outbid'
									}
								}

								// the customer has a bid card for this auction, their bid card is the
								// current high bidcard on the lot, and either the current high bid is
								// not recognized or there is a pending bid and the item has sold.  this
								// is for live auctions where certain states could arise needing this here.
								return {
									severity: 'error',
									message: 'You have been outbid.'
								}

								// the customer has a bid card for this auction, their bid card is the
								// current high bidcard for the lot, and either the current high bid is
								// not recognized or there is a pending bid and the item has not sold, they
								// must be placing their bid so tell them
							} else {
								//
								//
								// output for list view goes here
								//
								//
								if (viewType === 'list' || viewType === 'condensed_list') {
									return {
										severity: 'default',
										message: 'Placing Bid'
									}
								}

								return {
									severity: 'default',
									message: 'Placing your bid.'
								}
							}
						}

						// the customer has placed a bid on this item and their bid card is not the current
						// high bid card for this item
					} else if (inventoryId in state.customer.max_bids) {
						//
						//
						// output for list view goes here
						//
						//
						if (viewType === 'list' || viewType === 'condensed_list') {
							return {
								severity: 'error',
								message: 'Outbid'
							}
						}

						//
						// list_view here
						//

						// the item has sold
						if (getters.itemBiddingStatus(inventoryId).has_sold) {
							// the customer has a bid card for this auction, their bid card is not the current
							// high bid card for the item, and they have placed a bid on this item and it
							// has sold.
							return {
								severity: 'error',
								message: 'You were outbid.'
							}

							// the item has not sold,
						} else {
							if (
								getters.itemBiddingStatus(inventoryId).pending_bid_amount <
									getters.itemBiddingStatus(inventoryId).current_high_bid_amount &&
								getters.itemBiddingStatus(inventoryId).pending_bid === false
							) {
								// the customer has a bid card for this auction, they do not have a pending bid,
								// their bid card is not the current high bid card for the item, and they have
								// placed a bid on this item and it has not sold.
								return {
									severity: 'error',
									message: 'You have been outbid.'
								}
							}
							// the customer has a pending bid amount that is not less than the current high bid amount
							// we may be waiting for an update from pusher service to update the current high bid amount
							// so we will tell them they are placing their bid
							return {
								severity: 'default',
								message: 'Placing your bid.'
							}
						}
					}
				}

				//
				//
				// list view return here blank severity and message
				//
				//
				if (viewType === 'list' || viewType === 'condensed_list') {
					return {
						severity: '',
						message: ''
					}
				}

				// If it's a phone bid, don't show a message in bid status component
				// LL-838
				if (getters.customerPhoneBids(inventoryId)) {
					return {
						severity: '',
						message: ''
					}
				}

				//
				// (item_view return here)
				//
				// this item has not sold or passed, so bidding is open and the customer
				// does not have a bid pending on the item, so they haven't placed a bid
				// so tell them they have not placed a bid
				//
				return {
					severity: 'default',
					message: 'You have not placed a bid.'
				}
			}
			// They are not authenticated

			//
			//
			// list view return here blank severity and message
			//
			//
			if (viewType === 'list' || viewType === 'condensed_list') {
				return {
					severity: '',
					message: ''
				}
			}

			//
			// (item_view return here)
			//
			// tell them they need to sign in to bid
			//
			return {
				severity: 'default',
				message: 'Please sign in to bid.'
			}
		},

		// return all of our api responses
		apiResponse: (state) => {
			return state.apiResponse
		},

		// returns all of the pending api callcontexts
		apiPending: (state) => {
			return state.apiPending
		},

		// returns whether or not we have shipping orders that require attention
		hasShippingOrderThatRequiresAttention: (state, getters) => {
			// by default, they will have no shipping orders that require attention
			let status = false

			// loop through each shipping order in the store
			Object.keys(getters.shippingOrders).forEach(function (key) {
				// this shippign order requires customer action
				if (getters.shippingOrders[key].requires_action === true) {
					// they have a shipping order that requires action
					status = true

					// breaks out of this for each
					return false
				}
			})
			return status
		},

		// returns whether or not we have items that need to be picked up
		hasItemThatRequiresFullfillment: (state, getters) => {
			if (getters.requestQuoteInventoryIds.length > 0) {
				return true
			}

			return false
		},

		// returns whether or not we have unpaid invoices
		hasUnpaidInvoice: (state, getters) => {
			// by default, they will not have any unpaid invoices
			let status = false

			// loop through each invoice in the store
			Object.keys(getters.invoices).forEach(function (key) {
				// this invoice is not a shipping invoice and it is unpaid
				if (
					getters.invoices[key].shipping_order_invoice === false &&
					getters.invoices[key].payment_status === 'unpaid'
				) {
					// they have an unpaid invoice
					status = true

					// breaks out of this for each
					return false
				}
			})
			return status
		},

		// all of the customer's invoices
		invoices: (state) => {
			return state.invoices
		},

		// all of the customers shipping orders
		shippingOrders: (state) => {
			return state.shippingOrders
		},

		// get the lots remaining until an item will be on the stand
		lotsRemaining: (state, getters) => (inventoryId) => {
			// there is not current live inventory id OR we have a current live inventory id BUT don't have it in the item store
			if (
				getters.currentLiveInventoryId === null ||
				(getters.currentLiveInventoryId !== null &&
					getters.itemBiddingStatus(getters.currentLiveInventoryId) === null)
			) {
				// the inventory id provided is the current live lot
				if (getters.currentLiveInventoryId === inventoryId) {
					return 0

					// the inventory id provided is not the current live lot
				} else {
					// return the item's auction position as the lots remaining
					return getters.itemBiddingStatus(inventoryId).auction_position
				}
			}

			// return the items auction position minus the current live lot position as the lots remaining
			return (
				getters.itemBiddingStatus(inventoryId).auction_position -
				getters.itemBiddingStatus(getters.currentLiveInventoryId).auction_position
			)
		},

		// the countdown title
		countdownTitle: (state, getters) => (inventoryId) => {
			// we do not have the bidding status nor the item or the auction is paused
			if (
				!getters.itemBiddingStatus(inventoryId) ||
				!getters.item(inventoryId) ||
				getters.auctionStatus(inventoryId) === 'paused'
			) {
				return ''
			}

			// the item has sold or has passed
			if (
				getters.itemBiddingStatus(inventoryId).has_sold ||
				getters.itemBiddingStatus(inventoryId).has_passed
			) {
				return getters.itemSoldStatus(inventoryId)
			}

			// assign the time left to bid and the time left to the live auction
			let itemSecondsRemaining = Math.floor(
				getters.itemBiddingStatus(inventoryId).bidding_end_date_epoch - getters.now
			)
			let auctionSecondsRemaining = Math.floor(
				getters.item(inventoryId).auction_start_time - getters.now
			)

			// the auction has not started
			if (auctionSecondsRemaining > 0) {
				return 'Auction starts in:'
			}

			// this lot is selling now
			if (getters.itemBiddingStatus(inventoryId).current_live_lot) {
				// the virtual auctioneer is running the auction, and there's still time to bid
				if (getters.itemBiddingStatus(inventoryId).auction_use_virtual_auctioneer) {
					if (itemSecondsRemaining > 0 || getters.lotsRemaining(inventoryId) > 0) {
						return 'Selling in:'
					}
				}

				return 'This lot is selling now.'
			}

			// this lot is selling next
			if (getters.lotsRemaining(inventoryId) === 1) {
				return 'This lot is selling next.'
			}

			return 'Selling in:'
		},

		// the countdown clock
		countdownClock: (state, getters) => (inventoryId) => {
			let remainingTimeCounter = Math.floor(
				getters.itemBiddingStatus(inventoryId).bidding_end_date_epoch - getters.now
			)

			// create skeleton for our return data
			let displaySkeleton = {
				unitPrevious: '',
				unit: '',
				unitNext: '',
				unitNextNext: '',
				tensPrevious: '',
				tens: '',
				tensNext: '',
				tensNextNext: '',
				onesPrevious: '',
				ones: '',
				onesNext: '',
				onesNextNext: ''
			}

			// the object we're using to store the units/ones/tens for each days/hours/minutes/seconds
			let displayObjects = {}
			// object to store key/value pairs of units, and how many remaining (3 days, for instance)
			let remaining = {}

			// number of days remaining, and decrement the remainingTimeCounter
			remaining.days = Math.floor(remainingTimeCounter / (60 * 60 * 24))
			remainingTimeCounter = remainingTimeCounter % (60 * 60 * 24)

			// number of hours remaining, and decrement the remainingTimeCounter
			remaining.hours = Math.floor(remainingTimeCounter / (60 * 60))
			remainingTimeCounter = remainingTimeCounter % (60 * 60)

			// number of minutes remaining, and decrement the remainingTimeCounter
			remaining.minutes = Math.floor(remainingTimeCounter / 60)
			remainingTimeCounter = remainingTimeCounter % 60

			// number of seconds remaining
			remaining.seconds = remainingTimeCounter

			// array storing objects containing units, and number of seconds each unit contains (60 seconds in a minute, for example)
			let units = [
				{ key: 'days', value: 60 * 60 * 24 },
				{ key: 'hours', value: 60 * 60 },
				{ key: 'minutes', value: 60 },
				{ key: 'seconds', value: 1 }
			]

			// loop through the units, to flesh our our skeleton objects
			for (let i = 0; i < units.length; i++) {
				// initialize our object
				let obj = JSON.parse(JSON.stringify(displaySkeleton))
				// set the unit for the object
				obj.unit = units[i].key
				// set previous, next, and nextNext units for our object
				obj.unitPrevious =
					typeof units[i - 1] === 'undefined' || typeof units[i - 1].key === 'undefined'
						? ''
						: units[i - 1].key
				obj.unitNext =
					typeof units[i + 1] === 'undefined' || typeof units[i + 1].key === 'undefined'
						? ''
						: units[i + 1].key
				obj.unitNextNext =
					typeof units[i + 2] === 'undefined' || typeof units[i + 2].key === 'undefined'
						? ''
						: units[i + 2].key

				// the time incrementer in seconds (60 seconds for a minute, for example)
				let timeIncrement = units[i].value

				// get the tens value by dividing the remaining units by 10, and then dividing by 10 again, saving the remainder
				obj.tens = Math.floor(remaining[units[i].key] / 10) % 10
				if (obj.tens <= 0) {
					obj.tens = '&nbsp;'
				}
				// multiply the increment by the unit remaining to get the number of seconds, add/subtract some number of time increments (in seconds),
				// and get the remainder by dividing by 10 (after dividing by 10 initially to get 10s) to get the ones
				obj.tensPrevious =
					Math.floor(
						(remaining[units[i].key] * timeIncrement + 10 * timeIncrement) / timeIncrement / 10
					) % 10
				obj.tensNext =
					Math.floor(
						(remaining[units[i].key] * timeIncrement - 10 * timeIncrement) / timeIncrement / 10
					) % 10
				if (obj.tensNext <= 0) {
					obj.tensNext = '&nbsp;'
				}
				obj.tensNextNext =
					Math.floor(
						(remaining[units[i].key] * timeIncrement - 20 * timeIncrement) / timeIncrement / 10
					) % 10
				if (obj.tensNextNext <= 0) {
					obj.tensNextNext = '&nbsp;'
				}
				// get the ones value by dividing by 10 and taking the remainder
				obj.ones = remaining[units[i].key] % 10
				// if the ones unit is zero, and the tens unit is zero/does not exist, remove the unit text
				if (obj.tens === '&nbsp;' && obj.ones <= 0) {
					obj.ones = '&nbsp;'
					obj.unit = '&nbsp;'
				}
				// multiply the increment by the unit remaining to get the number of seconds, add/subtract some number of time increments (in seconds), and get the remainder by dividing by 10 to get the ones
				obj.onesPrevious =
					Math.floor((remaining[units[i].key] * timeIncrement + timeIncrement) / timeIncrement) % 10
				obj.onesNext =
					Math.floor((remaining[units[i].key] * timeIncrement - timeIncrement) / timeIncrement) % 10
				if (obj.tens === '&nbsp;' && obj.onesNext <= 0) {
					obj.onesNext = '&nbsp;'
				}
				obj.onesNextNext =
					Math.floor(
						(remaining[units[i].key] * timeIncrement - 2 * timeIncrement) / timeIncrement
					) % 10
				if (obj.tens === '&nbsp;' && obj.onesNextNext <= 0) {
					obj.onesNextNext = '&nbsp;'
				}

				// remove trailing 's' if unit is singular
				if (obj.ones === 1 && obj.tens === '&nbsp;') {
					obj.unit = obj.unit.replace(/s$/, '')
				}

				// add the calulated object to our storage object - note we have to do the stringify/JSON in order to pass by value (instead of by reference)
				displayObjects[units[i].key] = JSON.parse(JSON.stringify(obj))
			}

			// set default displayUnits
			let displayUnits = {}

			// set the primary units
			if (remaining.days > 0) {
				displayUnits.primary = displayObjects.days
				// set the secondary units, hours/days/seconds, depending on what is available
				if (remaining.hours > 0) {
					displayUnits.secondary = displayObjects.hours
				} else if (remaining.minutes > 0) {
					displayUnits.secondary = displayObjects.minutes
				} else {
					displayUnits.secondary = displayObjects.secons
				}
			} else if (remaining.hours > 0) {
				displayUnits.primary = displayObjects.hours
				// set the secondary units, minutes/seconds, depending on what is available
				if (remaining.minutes > 0) {
					displayUnits.secondary = displayObjects.minutes
				} else {
					displayUnits.secondary = displayObjects.seconds
				}
			} else if (remaining.minutes > 0) {
				displayUnits.primary = displayObjects.minutes
				displayUnits.secondary = displayObjects.seconds
			} else {
				// set the primary - secondary is blank object if primary is seconds
				displayUnits.primary = displayObjects.seconds
				displayUnits.secondary = JSON.parse(JSON.stringify(displaySkeleton))
			}

			// store the seconds remaining
			displayUnits.seconds_remaining = Math.floor(
				getters.itemBiddingStatus(inventoryId).bidding_end_date_epoch - getters.now
			)
			return displayUnits
		},

		// Check if item is in "preview" >2 weeks from start, real estate only
		isPreviewMode: (state, getters) => (inventoryId) => {
			let item = getters.item(inventoryId)

			if (item && item.auction_preview_mode === 'y') {
				return true
			}

			return false
		},
		isLoadingAccount: (state) => {
			return state.accountIsLoading
		},

		currentLiveInventoryId: (state) => {
			return state.currentLiveInventoryId
		},

		// IN PROGRESS GETTERS
		hasServiceLocations: (state) => {
			return state.hasServiceLocations
		},
		pickupItems: (state) => {
			return state.pickupItems
		},
		phoneList: (state) => {
			return state.phoneList
		},
		passwordlessLoginMessage: (state) => {
			return state.passwordlessLoginMessage
		},
		requestQuoteInventoryIds: (state) => {
			return state.requestQuoteInventoryIds
		},
		accountCardHistory: (state) => {
			return state.accountCardHistory
		},
		accountMenuShiftLeft: (state) => {
			return state.accountMenuShiftLeft
		},
		activeAccountTab: (state) => {
			return state.activeAccountTab
		},
		payInvoiceModalIsCardFormVisible: (state) => {
			return state.payInvoiceModalIsCardFormVisible
		},
		successfullyCreatedAccount: (state) => {
			return state.successfullyCreatedAccount
		},
		payInvoiceModalError: (state) => {
			return state.payInvoiceModalError
		},
		createAccountModalError: (state) => {
			return state.createAccountModalError
		},
		createAccountModalIsAwaitingResponse: (state) => {
			return state.createAccountModalIsAwaitingResponse
		},
		biddingHistories: (state) => {
			return state.biddingHistories
		},
		apiPath: (state) => {
			return state.serviceLocations.api.path
		},
		mainPusherSettings: (state) => {
			return state.serviceLocations.pusher_main
		},
		virtualAuctioneerPusherSettings: (state) => {
			return state.serviceLocations.pusher_virtual_auctioneer
		},
		isAuthenticated: (state) => {
			return state.isAuthenticated
		},
		twoFactorRequest: (state) => {
			return state.twoFactorRequest
		},
		lists: (state) => {
			return state.lists
		},
		liveMode: (state) => {
			return llGetUrlParameter('advanceWithPodium').length > 0
		},
		creditCardFormIsOpenInBiddingArea: (state) => {
			return state.creditCardFormIsOpenInBiddingArea
		},
		modal: (state) => {
			return state.modal
		},
		podium: (state) => {
			return state.podium
		},
		sortColumn: (state) => {
			return state.sortColumn
		},
		sortOrder: (state) => {
			return state.sortOrder
		},
		websiteMessage: (state) => {
			return state.websiteMessage
		},
		departments: (state) => {
			return state.departments
		},
		stories: (state) => {
			return state.stories
		},
		auctions: (state) => {
			return state.auctions
		},
		sessions: (state) => {
			return state.sessions
		},
		currentInvoice: (state) => {
			return state.currentInvoice
		},
		currentShippingOrder: (state) => {
			return state.currentShippingOrder
		},
		checkoutInvoiceId: (state) => {
			return state.checkoutInvoiceId
		},
		virtualAuctioneerHasCrashed: (state) => {
			return state.virtualAuctioneerCrashed
		}
	},

	/**
	 * Actions
	 */
	actions: {
		...actions,
		// updates the store with the current unix timestamp every 1000ms to be used
		// with the countdown clock to keep track of the time remaining to bid
		start({ commit }) {
			setInterval(() => {
				commit(UPDATE_CURRENT_TIMESTAMP)
			}, 1000)
		},

		// the axios wrapper that we make all of out api calls through
		apiCall({ commit, dispatch, getters }, payload = {}) {
			// a context was not provided
			if (typeof payload.postData.context === 'undefined') {
				// an action was provided
				if (typeof payload.postData.action !== 'undefined') {
					// set the payload context to be the action
					payload.postData.context = payload.postData.action

					// an action was not provided
				} else {
					// set the payload to blank
					payload.postData.context = ''
				}
			}

			dispatch('clearApiResponse', payload.postData.context)
			payload.postData.x_auth_token = $cookies.get('llatoken')
			commit(START_API_CALL, payload)

			// jeff, i have no idea why we wrapped some of the original axios calls
			// in a return, other than some far off memory of needing it for timing
			// purposes.  including here so now they are all wrapped in it.  i'm
			// not sure if this will mess anything up.  boy, do we need unit testing
			// more than ever.

			return axios
				.post(getters.apiPath + '/' + payload.apiEndpoint + '/', payload.postData, payload.config)
				.then((response) => {
					// store our post data and the api response in this object
					let parsedResponse = {}
					parsedResponse.response = response.data
					parsedResponse.request = payload.postData

					// these need to fire in order so the spinner stays until the entire chain
					// is complete.
					dispatch('saveApiResponse', parsedResponse).then(() => {
						commit(END_API_CALL, payload)
					})
					return response
				})
				.catch((error) => {
					if (error.response) {
						if (
							typeof error.response.data.message_id !== 'undefined' &&
							error.response.data.message_id === 'TOKEN_CHECK_FAILURE'
						) {
							$cookies.remove('llatoken')
						}
						let parsedError = {}
						parsedError.response = error.response.data
						parsedError.request = payload.postData
						dispatch('saveApiResponse', parsedError).then(() => {
							commit(END_API_CALL, payload)
						})
					} else {
						commit(END_API_CALL, payload)
					}
					return error.response
				})
		},
		// get a token for CertCapture eCommerce plugin
		getECommerceToken({ dispatch, commit, getters }, options) {
			// our api payload
			let apiPayload = {}
			apiPayload.apiEndpoint = 'customer'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_ecommerce_token'
			return dispatch('apiCall', apiPayload).then((response) => {
				// return the token
				return response.data.payload.token
			})
		},
		// get a single customer invoice (with arta and avatax values)
		getCustomerInvoice({ dispatch, commit, getters }, options) {
			// our api payload
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_customer_invoice'
			apiPayload.postData.invoice_id = options.hasOwnProperty('invoiceId')
				? options.invoiceId
				: null
			apiPayload.postData.recalculate_tax = options.hasOwnProperty('recalculateTax')
				? options.recalculateTax
				: null
			apiPayload.postData.tax_exemption_upload = options.hasOwnProperty('taxExemptionUpload')
				? options.taxExemptionUpload
				: null
			commit(SET_IS_LOADING_INVOICE, true)
			return dispatch('apiCall', apiPayload).then((response) => {
				// save the invoice data
				commit(SAVE_INVOICE_DATA, response.data.payload.invoices)
				commit(SET_IS_LOADING_INVOICE, false)
				if (options.hasOwnProperty('callback') && typeof options.callback === 'function') {
					options.callback()
				}
			})
		},
		// get the customer's invoice ids
		getCustomerInvoices({ dispatch, commit, getters }) {
			commit(SET_IS_LOADING_INVOICES, true)
			// our api payload
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_customer_invoices'
			dispatch('apiCall', apiPayload).then((response) => {
				commit(SET_IS_LOADING_INVOICES, false)
				// save the invoice data
				commit(SAVE_INVOICE_DATA, response.data.payload.invoices)
			})
		},
		/**
		 * Get the HTML for customer invoice receipt.
		 * Content-Type will be text/html
		 * @param {*} param0
		 * @param {*} options
		 * @returns Promise
		 */
		getCustomerInvoiceReceipt({ dispatch, commit, getters }, options) {
			// our api payload
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_customer_invoice_receipt'
			apiPayload.postData.invoice_id = options.hasOwnProperty('invoiceId')
				? options.invoiceId
				: null
			return dispatch('apiCall', apiPayload)
		},
		getInvoiceExemptionStatus({ dispatch, commit, getters }, options) {
			var apiPayload = {}
			apiPayload.apiEndpoint = 'customer'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_exemption_status'
			apiPayload.postData.invoice_id = options.hasOwnProperty('invoiceId')
				? options.invoiceId
				: null
			return dispatch('apiCall', apiPayload).then((response) => {
				// find the invoice inour state and apply the exemption status from the response to it
				const invoices = getters.invoices
				Object.keys(invoices).forEach((invoiceKey) => {
					const invoice = invoices[invoiceKey]
					if (Number(invoice.invoice_id) === Number(options.invoiceId)) {
						invoice.exemption_status = { ...response.data.payload.response }
						invoices[invoiceKey] = invoice
					}
				})
				commit(SAVE_INVOICE_DATA, invoices)
			})
		},
		identity({ dispatch, commit, getters }) {
			Fingerprint2.get((components) => {
				let fpHash = Fingerprint2.x64hash128(
					components
						.map((pair) => {
							return pair.value
						})
						.join(),
					31
				)
				components.splice(
					components
						.map(function (component) {
							return component.key
						})
						.indexOf('webgl'),
					1
				)
				components.splice(
					components
						.map(function (component) {
							return component.key
						})
						.indexOf('canvas'),
					1
				)
				let fpJson = JSON.stringify(components)

				// from our api payload
				let apiPayload = {}
				apiPayload.apiEndpoint = 'identity'
				apiPayload.postData = {
					x_auth_token: $cookies.get('llatoken'),
					fp_identity: $cookies.get('fp_identity'),
					fp_hash: fpHash,
					fp_json: fpJson
				}

				// send the api request - we don't really care about the response
				dispatch('apiCall', apiPayload).then((response) => {
					if (
						typeof response.data.payload !== 'undefined' &&
						response.data.payload !== null &&
						typeof response.data.payload.identity !== 'undefined' &&
						response.data.payload.identity !== null
					) {
						commit(SAVE_IDENTITY, { identity: response.data.payload.identity })
					}
				})
			})
		},

		// place a bid
		placeBid({ state, commit, dispatch, getters }, payload) {
			// from our api payload
			let apiPayload = {}
			apiPayload.apiEndpoint = 'bid'
			apiPayload.postData = {}
			apiPayload.postData.action = 'place_bid'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})

			// Set pending_bid to true.
			Vue.set(state.biddingStatuses['ITEMID_' + payload.inventory_id], 'pending_bid', true)
			const pendingBidAmount =
				typeof apiPayload.postData.bid_amount === 'string'
					? Number(apiPayload.postData.bid_amount.replace(/,/g, ''))
					: apiPayload.postData.bid_amount
			Vue.set(
				state.biddingStatuses['ITEMID_' + payload.inventory_id],
				'pending_bid_amount',
				pendingBidAmount
			)

			return dispatch('apiCall', apiPayload).then((response) => {
				// include the response and request in our payload to our mutation
				let parsedResponse = {}
				parsedResponse.response = response.data
				parsedResponse.request = apiPayload.postData

				// only process this as a successfull bid when the bid is actually placed
				if (parsedResponse.response.result === 'success') {
					// only add ecommerce tracking to bids on production
					if (getters.apiPath === 'https://www.lelandlittle.com/api') {
						// push ecommerce data to analytics
						if (
							typeof window.gtag === 'function' &&
							typeof parsedResponse.response.payload.bid_value !== 'undefined'
						) {
							try {
								window.gtag('event', 'purchase', {
									transaction_id: parsedResponse.request.inventory_id,
									affiliation: 'Leland Little Auction Platform',
									value: parsedResponse.response.payload.bid_value,
									currency: 'USD',
									tax: 0,
									shipping: 0,
									items: [
										{
											id: parsedResponse.response.payload.bid_id,
											name: getters.item(parsedResponse.request.inventory_id).lead,
											list_name: parsedResponse.request.auction_id,
											brand: getters.item(parsedResponse.request.inventory_id).category_name,
											category: getters.item(parsedResponse.request.inventory_id).category_name,
											quantity: 1,
											price: parsedResponse.response.payload.bid_value
										}
									]
								})
							} catch (e) {
								console.log(e)
								// no analytics sent
							}
						}
					}

					commit(BID_SUCCESS, parsedResponse)
					dispatch('addItemToList', {
						list_id: state.customer.bid_list_id,
						inventory_id: payload.inventory_id
					})
				} else {
					// Set pending_bid to false.
					Vue.set(state.biddingStatuses['ITEMID_' + payload.inventory_id], 'pending_bid', false)
				}
				return response
			})
		},

		// the dispatch that authenticates our user
		authenticate({ dispatch, commit }, payload = {}) {
			// from our api payload
			let apiPayload = {}
			apiPayload.apiEndpoint = 'authenticate'
			apiPayload.postData = {}
			apiPayload.postData.action = 'authenticate'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			return dispatch('apiCall', apiPayload).then((response) => {
				if (response.data.message_id === 'TWO_FACTOR_REQUEST') {
					return true // return true to the caller of this function, so we can navigate to new page to enter the pin
				}
				commit(SAVE_AUTHENTICATION_STATE, {
					isAuthenticated: response.data.result === 'success',
					token: response.data.payload.token
				})
				// www will send page option on checkout view
				switch (payload.page) {
					case 'checkout':
						// checkout view will call getCustomerInvoice for select invoice, we don't need all of them
						dispatch('identity')
						dispatch('getAllCustomerShippingOrders')
						dispatch('getRequestQuoteInventoryIds')
						break
					default:
						dispatch('getAllCustomerShippingOrders')
						dispatch('getRequestQuoteInventoryIds')
						dispatch('identity')
						break
				}
			})
		},
		authenticate2FA({ dispatch, commit }, payload = {}) {
			commit(SAVE_AUTHENTICATION_STATE, {
				isAuthenticated: true,
				token: payload
			})
			dispatch('getAllCustomerShippingOrders')
			dispatch('getRequestQuoteInventoryIds')
			dispatch('identity')
		},
		updateInvoices({ dispatch, commit }, payload = {}) {
			commit(SAVE_INVOICE_DATA, payload.invoice)
		},
		// use this dispatch to get a single list from the api and store in vuex
		getList({ dispatch, commit }, payload = {}) {
			// form our api payload
			let apiPayload = {}
			apiPayload.apiEndpoint = 'list'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_list'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then((response) => {
				if (typeof response.data.payload !== 'undefined') {
					// save the list
					commit(SAVE_LIST, response.data.payload)

					// save the items from the list
					commit(SAVE_ITEMS, response.data.payload['LISTID_' + payload.list_id].items)

					// save the bidding statuses of the items on the list
					commit(
						SAVE_BIDDING_STATUSES,
						response.data.payload['LISTID_' + payload.list_id].bidding_statuses
					)
				}
			})
		},

		/**
		 * Get a list of favorites from api
		 *
		 * @public
		 */
		getFavoritesList({ dispatch, commit }, payload = {}) {
			commit(SET_IS_LOADING_FAVORITES, true)
			// form our api payload
			let apiPayload = {}
			apiPayload.apiEndpoint = 'favorite'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_list'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then((response) => {
				commit(SET_IS_LOADING_FAVORITES, false)
				if (typeof response.data.payload !== 'undefined') {
					// save the list
					commit(SAVE_LIST, response.data.payload)
					// save the items from the list
					commit(SAVE_ITEMS, response.data.payload['LISTID_' + payload.list_id].items)
					// save the bidding statuses of the items on the list
					commit(
						SAVE_BIDDING_STATUSES,
						response.data.payload['LISTID_' + payload.list_id].bidding_statuses
					)
					// If we request a paginated response: set page number, total items, total pages
					if (payload.hasOwnProperty('page')) {
						commit(SET_FAVORITES_CARD_PAGINATION_STATUS, {
							page: response.data.payload['LISTID_' + payload.list_id].page,
							total: response.data.payload['LISTID_' + payload.list_id].total,
							total_pages: response.data.payload['LISTID_' + payload.list_id].total_pages
						})
					}
					if (payload.hasOwnProperty('callback') && typeof payload.callback === 'function') {
						payload.callback()
					}
				}
			})
		},

		// this dispatch returns one or more items from the api and stores in vuex
		getItems({ dispatch, commit }, payload = {}) {
			// handle undefined item_ids in the payload
			if (typeof payload.item_ids === 'undefined') {
				return
			}

			// form our api payload
			let apiPayload = {}
			apiPayload.apiEndpoint = 'item'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_items'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			// one or more item ids were provided
			if (typeof payload.item_ids !== 'undefined') {
				if (payload.item_ids.length > 0) {
					dispatch('apiCall', apiPayload).then((response) => {
						// save the items to the store
						commit(SAVE_ITEMS, response.data.payload.items)
						dispatch('getBiddingStatuses', payload)
					})
				}
			}
		},

		// a dispatch that asks for the bidding status for one or more items and stores in vuex
		getBiddingStatuses({ state, dispatch, commit }, payload = {}) {
			let includesCurrentLiveLot = false

			// form our api payload
			let apiPayload = {}
			apiPayload.apiEndpoint = 'item/current-bid'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_bidding_statuses'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})

			// the item ids we will ultimately ask for
			let requestItemIds = []

			// only if the item_ids exist in the payload
			if (typeof payload.item_ids !== 'undefined') {
				// check to see which bidding statuses we already have in the store
				payload.item_ids.forEach(function (key) {
					// the request includes the current live lot
					if (
						typeof key !== 'undefined' &&
						typeof state.currentLiveInventoryId !== 'undefined' &&
						key === state.currentLiveInventoryId
					) {
						includesCurrentLiveLot = true
					}

					// we do not have the bidding status for this item in the store
					if (typeof state.biddingStatuses['ITEMID_' + key] === 'undefined') {
						// add to our array of item ids for which we will request bidding statuses
						requestItemIds.push(key)
					}
				})

				// we need to ask for bidding statuses to complete the request
				if (requestItemIds.length > 0) {
					// place our request item ids into the api payload
					apiPayload.postData['item_ids'] = requestItemIds

					// fire off the call to get the bidding statuses
					dispatch('apiCall', apiPayload).then((response) => {
						commit(SAVE_BIDDING_STATUSES, response.data.payload.bidding_statuses)
						commit(SAVE_BIDDING_HISTORY, response.data.payload.bidding_statuses)
						if (includesCurrentLiveLot) {
							dispatch(
								'savePodiumState',
								response.data.payload.bidding_statuses['ITEMID_' + state.currentLiveInventoryId]
							)
						}
					})
				}
			}
		},

		// save the response for an api call in the given context
		saveApiResponse({ commit }, payload) {
			commit(SAVE_API_RESPONSE, payload)
		},

		// clear the response for an api call in the given context
		clearApiResponse({ commit }, payload) {
			commit(CLEAR_API_RESPONSE, payload)
		},

		// the dispatch that authenticates our user
		createAccount({ dispatch, commit }, payload = {}) {
			// from our api payload
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'create_account'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			Fingerprint2.get((components) => {
				let fpHash = Fingerprint2.x64hash128(
					components
						.map((pair) => {
							return pair.value
						})
						.join(),
					31
				)
				components.splice(
					components
						.map(function (component) {
							return component.key
						})
						.indexOf('webgl'),
					1
				)
				components.splice(
					components
						.map(function (component) {
							return component.key
						})
						.indexOf('canvas'),
					1
				)
				let fpJson = JSON.stringify(components)

				apiPayload.postData.fp_hash = fpHash
				apiPayload.postData.fp_json = fpJson
				apiPayload.postData.fp_identity = $cookies.get('fp_identity')

				dispatch('apiCall', apiPayload).then((response) => {
					commit(CREATE_ACCOUNT_SUCCESS, response.data)
					commit(SAVE_IDENTITY, { identity: response.data.payload.identity })
				})
			})
		},

		addCard({ dispatch, commit, state }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'add_card'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then((response) => {
				// include the response and request in our payload to our mutation
				let parsedResponse = {}
				parsedResponse.response = response.data
				parsedResponse.request = apiPayload.postData
				// the card was successfully added
				if (parsedResponse.response.result === 'success') {
					// the response will contain the customers updated cc list, so store it
					commit('SAVE_CREDIT_CARDS', parsedResponse.response.payload.credit_cards)
					// they were on an invoice when they added the card
					if (state.currentInvoice > 0) {
						// pay the invoice with the card they just added
						let payInvoicePayload = {
							invoice_ids: [state.currentInvoice],
							amount: state.invoices['INVOICEID_' + state.currentInvoice].invoice_balance,
							credit_card_id: parsedResponse.response.payload.credit_cards[0].id,
							context: 'pay_invoice'
						}
						// pay the invoice
						dispatch('payInvoice', payInvoicePayload)
					}
				}
			})
		},

		verifyTwoFactorPhoneNumber({ dispatch, commit }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'verify_two_factor_phone_number'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			return dispatch('apiCall', apiPayload).then((apiResponse) => {
				commit('SAVE_TWO_FACTOR_PRIMARY_PHONE_NUMBER', payload.phone_number)
			})
		},

		addTwoFactorPhoneNumber({ dispatch }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'add_two_factor_phone_number'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			return dispatch('apiCall', apiPayload)
		},

		updatePassword({ dispatch }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'update_password'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			return dispatch('apiCall', apiPayload)
		},

		getAccount({ dispatch, commit, state }, payload = {}) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_account'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			commit(SET_IS_LOADING_ACCOUNT, true)
			return dispatch('apiCall', apiPayload).then((apiResponse) => {
				// Store our customer
				commit(SAVE_CUSTOMER, apiResponse.data.payload.customer)
				commit(SET_IS_LOADING_ACCOUNT, false)
				// Get our bid list
				dispatch('getList', {
					list_id: state.customer.bid_list_id,
					context: 'get_bid_list'
				})

				// Get customer favorites for items in vue store & on page
				const itemsArray = state.items ? Object.values(state.items) : []
				let inventoryIds =
					itemsArray && itemsArray.length > 0
						? itemsArray.reduce((collector, current) => {
								if (current && current.inventory_id) {
									collector.push(current.inventory_id)
								}
								return collector
						  }, [])
						: []

				const itemIds = window.itemIds
				// Combine inventory ids in state with itemIds on page.
				if (itemIds && itemIds.length > 0) {
					inventoryIds = [...inventoryIds, ...itemIds]
				}
				if (inventoryIds.length > 0) {
					dispatch('getFavoritesList', {
						list_id: state.customer.favorite_list_id,
						context: 'get_favorite_list',
						inventory_ids: inventoryIds
					})
				}

				// they have incomplete customer data
				if (
					state.customer.first_name === null ||
					state.customer.last_name === null ||
					state.customer.phone === null ||
					state.customer.billing_street_address === null ||
					state.customer.billing_city === null ||
					state.customer.billing_state === null ||
					state.customer.billing_zip === null
				) {
					// push them to the sign in modal onto the create an account form
					let modalPayload = {
						component: 'SignIn',
						props: {
							showUpdateAccount: true
						}
					}
					dispatch('showModal', modalPayload)
					dispatch('insertAccountHistory', 'Create an Account')
				}
			})
		},

		/**
		 * Get a customer's favorites.
		 *
		 * Customize the response by setting attributes of the payload.
		 * - page
		 * 		To get a paginated response
		 * - inventory_ids
		 * 		To limit a set of favorites to a set of inventory ids
		 * - auction_id
		 * 		To get favorite items that belong to a specific auction
		 *
		 * @public
		 */
		getFavorites({ dispatch, commit, state }, payload = {}) {
			dispatch('getFavoritesList', {
				list_id: state.customer.favorite_list_id,
				context: 'get_favorite_list',
				...payload
			})
		},

		searchItems({ dispatch }, payload = {}) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'search'
			apiPayload.postData = {}
			apiPayload.postData.action = 'search_inventory'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload)
		},
		passwordlessLogin({ dispatch }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'one_time'
			apiPayload.postData = {}
			apiPayload.postData.action = 'passwordless_authentication'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload)
		},
		payInvoice({ dispatch, getters, commit }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account/invoice/pay'
			apiPayload.postData = {}
			apiPayload.postData.action = 'pay_invoice'
			let payingInvoiceIds = getters.payingInvoiceIds
			let removeInvoiceIds = []
			for (let i = 0; i < payload.invoice_ids.length; i++) {
				let invoiceId = payload.invoice_ids[i]
				if (payingInvoiceIds.indexOf(invoiceId) > -1) {
					return
				}
				payingInvoiceIds.push(invoiceId)
				removeInvoiceIds.push(invoiceId)
			}
			commit(UPDATE_PAYING_INVOICE_IDS, payingInvoiceIds)
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then((response) => {
				// include the response and request in our payload to our mutation
				let parsedResponse = {}
				parsedResponse.response = response.data
				parsedResponse.request = apiPayload.postData

				// the payment was a success
				if (parsedResponse.response.result === 'success') {
					// get any items they have paid for that need fullfillment arrangements
					dispatch('getRequestQuoteInventoryIds').then(() => {
						// get their unpaid invoices
						dispatch('getInvoicesById', {
							invoice_ids: [parsedResponse.request.invoice_ids[0]]
						}).then(() => {
							// they do not have any unpaid invoices and they do have
							// paid items that need fullfillment arrangements
							if (!getters.hasUnpaidInvoice && getters.requestQuoteInventoryIds.length > 0) {
								// push them to the fullfillment page
								dispatch('insertAccountHistory', 'Arrange Shipping or Pick up')
							}

							// get the invoice and shipping orders
							dispatch('getAllCustomerShippingOrders')
						})
					})
				} else {
					let payingInvoiceIds = getters.payingInvoiceIds
					payingInvoiceIds = payingInvoiceIds.filter(function (invoiceId) {
						return removeInvoiceIds.indexOf(invoiceId) < 0
					})
					commit(UPDATE_PAYING_INVOICE_IDS, payingInvoiceIds)
				}
			})
		},
		deleteExemptionCertificate({ dispatch, commit }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'customer'
			apiPayload.postData = {}
			apiPayload.postData.action = 'delete_certificate'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			return dispatch('apiCall', apiPayload)
		},
		downloadExemptionCertificate({ dispatch, commit }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'customer'
			apiPayload.postData = {}
			apiPayload.postData.action = 'download_certificate'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			return dispatch('apiCall', apiPayload)
		},
		updateExemptionStatus({ dispatch, commit }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'customer'
			apiPayload.postData = {}
			apiPayload.postData.action = 'update_tax_exemption_status'
			if (payload) {
				Object.keys(payload).forEach(function (key) {
					apiPayload.postData[key] = payload[key]
				})
			}
			return dispatch('apiCall', apiPayload)
		},
		getInvoicesById({ dispatch, commit }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'invoice'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_invoices'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then((response) => {
				commit(SAVE_INVOICE_DATA, response.data.payload.invoices)
			})
		},
		getArtaShippingStatusForInvoice({ dispatch, commit }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'shipping'
			apiPayload.postData = {}
			apiPayload.postData.action = 'arta_shipping_status'
			apiPayload.postData['shippingId'] = payload

			return dispatch('apiCall', apiPayload)
		},
		requestArtaQuotes({ dispatch, commit }, payload) {
			const { data, callback } = payload
			var postData = {
				action: 'arta_request_quotes',
				...data
			}
			var apiPayload = {}
			apiPayload.apiEndpoint = 'shipping'
			apiPayload.postData = postData
			commit(SET_IS_LOADING_ARTA_REQUEST_QUOTES, true)
			dispatch('apiCall', apiPayload).then((response) => {
				commit(SET_IS_LOADING_ARTA_REQUEST_QUOTES, false)
				if (callback && typeof callback === 'function') {
					callback(response)
				}
			})
		},
		setInvoiceNeedsAttention({ dispatch, commit }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'invoice'
			apiPayload.postData = {}
			apiPayload.postData.action = 'needs_attention'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then((response) => {
				// commit(SAVE_INVOICE_DATA, response.data.payload.invoices)
			})
		},
		/**
		 * Allow customer to select a different payment method
		 *
		 * @param {*} param0
		 * @param {*} payload
		 * @returns
		 */
		cancelSelectedInvoicePaymentType({ dispatch, commit }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'invoice'
			apiPayload.postData = {}
			apiPayload.postData.action = 'cancel_selected_payment_type'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			return dispatch('apiCall', apiPayload).then((response) => {
				// Fetch the invoice again
				return dispatch('getCustomerInvoice', {
					invoiceId: payload.invoice_id
				})
			})
		},
		processShippingArrangement({ dispatch }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'shipping'
			apiPayload.postData = {}
			apiPayload.postData.action = 'request_quote'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then((response) => {
				dispatch('getRequestQuoteInventoryIds')
				dispatch('getAllCustomerShippingOrders')
			})
		},
		processPickupArrangement({ dispatch }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'shipping'
			apiPayload.postData = {}
			apiPayload.postData.action = 'pickup'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then(() => {
				dispatch('getRequestQuoteInventoryIds')
				dispatch('getAllCustomerShippingOrders')
			})
		},
		getRequestQuoteInventoryIds({ dispatch, commit }, payload = {}) {
			commit(CLEAR_REQUEST_QUOTE_INVENTORY_IDS)
			let apiPayload = {}
			apiPayload.apiEndpoint = 'shipping'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_quote_inventory'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then((response) => {
				if (typeof response.data.payload.item_ids !== 'undefined') {
					store.dispatch('getItems', {
						item_ids: response.data.payload.item_ids
					})
					store.dispatch('getBiddingStatuses', {
						item_ids: response.data.payload.item_ids
					})
					commit(SAVE_REQUEST_QUOTE_INVENTORY_IDS, response.data.payload.item_ids)
				}
			})
		},
		getAllCustomerShippingOrders({ commit, dispatch }, payload = {}) {
			commit(CLEAR_SHIPPING_ORDERS)
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_all_customer_shipping_orders'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then((response) => {
				commit(SAVE_SHIPPING_ORDER_DATA, response.data.payload)
			})
		},
		approveShippingOrderQuote({ dispatch }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'shipping'
			apiPayload.postData = {}
			apiPayload.postData.action = 'approve_quote'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then((response) => {
				// include the response and request in our payload to our mutation
				let parsedResponse = {}
				parsedResponse.response = response.data
				parsedResponse.request = apiPayload.postData

				// get the invoice that was created when we approved the quote
				store
					.dispatch('getInvoicesById', {
						invoice_ids: [parsedResponse.response.payload.invoice_id]
					})
					.then(() => {
						// redirect them to the invoice for this shipping order
						store.dispatch('updateCurrentInvoice', parsedResponse.response.payload.invoice_id)
						store.dispatch('insertAccountHistory', 'Invoice')

						// get all their shipping orders
						store.dispatch('getAllCustomerShippingOrders')
					})
			})
		},
		/**
		 * Validate an address on the API
		 * @param {*} param0
		 * @param {*} payload
		 */
		avalaraValidateAddress({ commit, dispatch }, payload) {
			var apiPayload = {}
			apiPayload.apiEndpoint = 'shipping'
			apiPayload.postData = {}
			apiPayload.postData.action = 'avalara_validate_address'
			Object.keys(payload.address).forEach(function (key) {
				apiPayload.postData[key] = payload.address[key]
			})
			commit(SET_IS_VALIDATING_ADDRESS, true)
			dispatch('apiCall', apiPayload).then((response) => {
				commit(SET_IS_VALIDATING_ADDRESS, false)
				if (payload && payload.callback && typeof payload.callback === 'function') {
					payload.callback(response)
				}
			})
		},
		/**
		 * Sets an invoice as a "Pickup"
		 */
		setPickup({ commit, dispatch }, payload) {
			const { data, callback } = payload
			var apiPayload = {
				apiEndpoint: 'shipping',
				postData: {
					action: 'pickup_no_shipping',
					...data
				}
			}
			commit(SET_IS_LOADING_PICKUP_NO_SHIPPING, true)
			dispatch('apiCall', apiPayload).then((response) => {
				commit(SET_IS_LOADING_PICKUP_NO_SHIPPING, false)
				if (callback && typeof callback === 'function') {
					callback(response)
				}
			})
		},
		cancelPickup({ dispatch }, payload) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'shipping'
			apiPayload.postData = {}
			apiPayload.postData.action = 'cancel_pickup'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then(() => {
				store.dispatch('getRequestQuoteInventoryIds')
				store.dispatch('getAllCustomerShippingOrders')
				store.dispatch('insertAccountHistory', 'Shipping')
			})
		},
		getCurrentLiveInventoryId({ dispatch, commit }) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'podium'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_current_live_lot'

			// Check for server rendered live inventory id
			const lla = window.lla || {}
			if (lla && lla.hasOwnProperty('currentLiveLot')) {
				if (Number(lla.currentLiveLot) > 0) {
					commit(SAVE_LIVE_INVENTORY_ID, lla.currentLiveLot)
				}
			}

			// get the current live inventory id
			dispatch('apiCall', apiPayload).then((getCurrentLiveLotResponse) => {
				// an inventory_id was returned
				if (getCurrentLiveLotResponse.data.payload.inventory_id !== null) {
					// save the current live inventory id
					commit(SAVE_LIVE_INVENTORY_ID, getCurrentLiveLotResponse.data.payload.inventory_id)

					// get the current live inventory object
					dispatch('apiCall', {
						apiEndpoint: 'item',
						postData: {
							action: 'get_items',
							item_ids: [getCurrentLiveLotResponse.data.payload.inventory_id]
						}
					})
				} else {
					// clear the current live inventory id
					commit(SAVE_LIVE_INVENTORY_ID, null)

					// clear the current live inventory id
					lla.currentLiveLot = null
				}
			})
		},

		showModal({ commit }, payload) {
			document.body.classList.add('modalOpen')
			if (typeof payload.props === 'undefined') {
				payload.props = {}
			}

			if (payload.component) {
				if (payload.component === 'AccountPage') {
					window.location.hash = menuConstants.URL_HASH_ACCOUNT_DETAILS
				}
			}

			commit(SHOW_MODAL, payload)
		},

		hideModal({ commit }) {
			document.body.classList.remove('modalOpen')
			commit(HIDE_MODAL)
		},

		addItemToList({ commit, dispatch }, payload = {}) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'list'
			apiPayload.postData = {}
			apiPayload.postData.action = 'add_to_list'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then((response) => {
				commit(ADD_ITEM_TO_LIST, payload)
			})
		},

		removeItemFromList({ commit, dispatch }, payload = {}) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'list'
			apiPayload.postData = {}
			apiPayload.postData.action = 'remove_from_list'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			dispatch('apiCall', apiPayload).then((response) => {
				commit(REMOVE_ITEM_FROM_LIST, payload)
			})
		},

		removeFavorites({ commit, dispatch }, payload = {}) {
			let apiPayload = {}
			apiPayload.apiEndpoint = 'favorite'
			apiPayload.postData = {}
			apiPayload.postData.action = 'remove_favorites'
			Object.keys(payload).forEach(function (key) {
				apiPayload.postData[key] = payload[key]
			})
			return dispatch('apiCall', apiPayload)
		},

		deleteInvoiceData({ commit }, payload) {
			commit(DELETE_INVOICE_DATA, payload)
		},

		getShipment({ getters }, payload) {
			axios
				.post(getters.apiPath + '/shipping/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'get_shipment',
					shipping_order_id: payload
				})
				.then((response) => {})
		},

		getPickup({ commit, getters }) {
			let payload = {
				x_auth_token: $cookies.get('llatoken'),
				action: 'get_pickup'
			}
			axios.post(getters.apiPath + '/shipping/', payload).then((response) => {
				commit(SAVE_PICKUP_ITEMS, response.data)
			})
		},
		insertAccountHistory({ commit, dispatch }, payload) {
			if (payload === constants.MENU_ITEM_INVOICES) {
				dispatch('getCustomerInvoices')
			}
			commit(INSERT_ACCOUNT_HISTORY, payload)
			// LL-1188 - Clear the place_bid apiCall error before open account card: bid list, favorites list
			if (payload === constants.MENU_ITEM_BIDS || payload === constants.MENU_ITEM_FAVORITES) {
				dispatch('clearApiResponse', 'place_bid')
			}
		},
		deleteAccountHistory({ commit }) {
			commit(DELETE_ACCOUNT_HISTORY)
		},
		clearAllAccountHistory({ commit }) {
			commit(CLEAR_ALL_ACCOUNT_HISTORY)
		},
		accountMenuShiftLeft({ commit }, payload) {
			commit(ACCOUNT_MENU_SHIFT_LEFT, payload)
		},
		showPayInvoiceCardForm({ commit }) {
			commit(SHOW_PAY_INVOICE_CARD_FORM)
		},
		hidePayInvoiceCardForm({ commit }) {
			commit(HIDE_PAY_INVOICE_CARD_FORM)
		},
		clearPayInvoiceModalError({ commit }) {
			commit(CLEAR_PAY_INVOICE_MODAL_ERROR)
		},
		resetAccountMenu({ commit }) {
			commit(RESET_ACCOUNT_MENU)
		},
		turnOffPendingBid({ commit }, payload) {
			commit(FINISH_PROCESSING_BID, payload)
		},
		setActiveAccountTab({ commit }, payload) {
			commit(SET_ACTIVE_ACCOUNT_TAB, payload)
		},
		setCreditCardFormIsOpenInBiddingArea({ commit }, payload) {
			commit(SET_CREDIT_CARD_FORM_IS_OPEN_IN_BIDDING_AREA, payload)
		},

		processPusherUpdate({ commit, dispatch }, payload) {
			if (payload.action.name === 'virtual_auctioneer_crash') {
				commit(SAVE_VIRTUAL_AUCTIONEER_CRASHED, true)
			} else {
				// save the bidding status and bidding history of any item updates get received from pusher
				commit(SAVE_BIDDING_STATUSES, payload.item_updates)
				commit(SAVE_BIDDING_HISTORY, payload.item_updates)

				// save the podium state for all messages
				dispatch('savePodiumState', payload.podium)

				commit(SAVE_LIVE_INVENTORY_ID, payload.podium.inventory_id)
			}
		},

		setServiceLocations({ commit }, payload) {
			commit(SAVE_SERVICE_LOCATIONS, payload)
		},

		generateRandomContext() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = (Math.random() * 16) | 0
				var v = c === 'x' ? r : (r & 0x3) | 0x8
				return v.toString(16)
			})
		},

		processVirtualAuctioneerUpdate({ commit, dispatch }, payload) {
			commit(SAVE_VIRTUAL_AUCTIONEER_MESSAGE, payload)
		},
		processVirtualAuctioneerCrash({ commit, dispatch }, payload) {
			commit(SAVE_VIRTUAL_AUCTIONEER_CRASHED, payload)
		},
		bidCards({ commit }) {
			commit(CUSTOMER_BID_CARDS)
		},
		updateAccount({ commit, getters }, payload) {
			commit(CREATE_ACCOUNT) // show spinner
			return axios
				.post(getters.apiPath + '/account/', {
					action: 'update_account',
					x_auth_token: $cookies.get('llatoken'),
					first_name: payload.first_name,
					last_name: payload.last_name,
					email: payload.email,
					password: payload.password,
					phone: payload.phone,
					sms: payload.sms,
					street_address: payload.street_address,
					city: payload.city,
					state: payload.state,
					zip: payload.zip,
					country: payload.country
				})
				.then((response) => {
					commit(CREATE_ACCOUNT_SUCCESS, response.data)
				})
				.catch((error) => {
					commit(CREATE_ACCOUNT_ERROR, error.response.data.message)
				})
		},
		uploadCertificate({ commit, getters }, payload) {
			payload.data.append('x_auth_token', $cookies.get('llatoken'))
			return axios.post(getters.apiPath + '/' + payload.apiEndpoint + '/', payload.data, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			})
		},
		getCertificateList({ commit, getters }, payload) {
			return axios.post(getters.apiPath + '/' + payload.apiEndpoint + '/', {
				x_auth_token: $cookies.get('llatoken'),
				...payload.data
			})
		},
		updateCurrentInvoice({ commit }, payload) {
			commit(UPDATE_CURRENT_INVOICE, payload)
		},
		updateCurrentShippingOrder({ commit }, payload) {
			commit(UPDATE_CURRENT_SHIPPING_ORDER, payload)
		},
		updateCustomerNotifications({ commit, getters }, payload) {
			// update the store before we send the data
			commit(UPDATE_CUSTOMER_SMS_NUMBER, payload.sms_number)
			commit(UPDATE_CUSTOMER_SMS_OUTBID, payload.sms_outbid)
			commit(UPDATE_CUSTOMER_EMAIL_OUTBID, payload.email_outbid)

			// we have issues where the sms outbid is yes and the number is empty -
			// we don't want to process, so return false
			if (payload.sms_outbid === 'y' && payload.sms_number === '') {
				return false
			}
			axios
				.post(getters.apiPath + '/account/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'update_customer_notifications',
					notifications: payload
				})
				.then((response) => {})
				.catch((error) => {
					console.error(error)
				})
		},
		updateCustomerSmsNumber({ commit }, payload) {
			commit(UPDATE_CUSTOMER_SMS_NUMBER, payload)
		},
		updateCustomerSmsOutbid({ commit }, payload) {
			commit(UPDATE_CUSTOMER_SMS_OUTBID, payload)
		},
		updateCustomerShowTaxExemptPopup({ commit, getters }, payload) {
			// update the store before we send the data
			commit(UPDATE_CUSTOMER_SHOW_TAX_EXEMPT_POPUP, payload.show_tax_exempt_popup)

			return axios.post(getters.apiPath + '/customer/', {
				x_auth_token: $cookies.get('llatoken'),
				action: 'update_customer_show_tax_exempt_popup',
				show_tax_exempt_popup: payload.show_tax_exempt_popup
			})
		},
		logout({ commit }) {
			$cookies.remove('llatoken')
			commit(SAVE_AUTHENTICATION_STATE, { isAuthenticated: false })
		},
		cancelBid({ commit }) {
			commit(CANCEL_BID)
		},
		startPhoneBid({ commit }, payload) {
			commit(START_PHONE_BID, payload)
		},
		cancelPhoneBid({ commit }, payload) {
			commit(CANCEL_PHONE_BID, payload)
		},
		clearBidState({ commit }) {
			commit(CLEAR_BID_STATE)
		},
		saveWebsiteMessage({ commit, getters }) {
			axios.get(getters.apiPath + '/podium/').then((response) => {
				commit(UPDATE_WEBSITE_MESSAGE, response.data.website_message)
			})
		},
		openBidding({ getters }, payload) {
			axios
				.post(getters.apiPath + '/clerk/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'open_bidding',
					inventory_id: payload.inventory_id
				})
				.then(() => {})
		},
		closeBidding({ getters }, payload) {
			axios
				.post(getters.apiPath + '/clerk/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'close_bidding',
					inventory_id: payload.inventory_id
				})
				.then(() => {})
		},
		passLot({ getters }, payload) {
			axios
				.post(getters.apiPath + '/clerk/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'pass_lot',
					inventory_id: payload.inventory_id
				})
				.then(() => {})
		},
		sellLot({ getters }, payload) {
			axios
				.post(getters.apiPath + '/clerk/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'sell_lot',
					inventory_id: payload.inventory_id
				})
				.then(() => {})
		},
		nextLot({ getters }, payload) {
			axios
				.post(getters.apiPath + '/clerk/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'next_lot',
					inventory_id: payload.inventory_id
				})
				.then(() => {
					// pusher update will come and update so dont commit here
					// commit(NEXT LOT, payload)
				})
		},
		endAuction({ commit, getters }, payload) {
			axios
				.post(getters.apiPath + '/clerk/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'end_auction',
					auction_id: payload.auction_id,
					inventory_id: payload.inventory_id
				})
				.then(() => {
					// pusher update will come and update so dont commit here
					// commit(SET LOT, payload)
				})
		},
		pauseAuction({ commit, getters }, payload) {
			axios
				.post(getters.apiPath + '/clerk/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'pause_auction',
					auction_id: payload.auction_id,
					inventory_id: payload.inventory_id
				})
				.then(() => {
					// pusher update will come and update so dont commit here
					// commit(SET LOT, payload)
				})
		},
		startVirtualAuctioneer({ commit, getters }, payload) {
			axios
				.post(getters.apiPath + '/clerk/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'start_virtual_auctioneer',
					auction_id: payload.auction_id,
					live_auctioneers_url: payload.live_auctioneers_url,
					invaluable_url: ''
				})
				.then(() => {
					// pusher update will come and update so dont commit here
					// commit(SET LOT, payload)
				})
		},
		setLot({ commit, getters }, payload) {
			axios
				.post(getters.apiPath + '/clerk/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'set_lot',
					auction_id: payload.auction_id,
					lot_number: payload.lot_number
				})
				.then(() => {
					// pusher update will come and update so dont commit here
					// commit(SET LOT, payload)
				})
		},
		sendPodiumMessage({ commit, getters }, payload) {
			axios
				.post(getters.apiPath + '/clerk/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'send_message',
					message: payload.message,
					inventory_id: payload.inventory_id
				})
				.then(() => {
					// pusher update will come and update so dont commit here
					// commit(SELL_LOT, payload)
				})
		},
		startAuction({ commit, getters }, payload) {
			axios
				.post(getters.apiPath + '/clerk/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'start_auction',
					auction_id: payload.auction_id,
					inventory_id: payload.inventory_id
				})
				.then(() => {
					// pusher update will come and update so dont commit here
					// payload = response
					// payload.showBanner = true
					// commit(UPDATE_PODIUM, payload)
				})
		},
		resumeAuction({ commit, getters }, payload) {
			axios
				.post(getters.apiPath + '/clerk/', {
					x_auth_token: $cookies.get('llatoken'),
					action: 'resume_auction',
					auction_id: payload.auction_id,
					inventory_id: payload.inventory_id
				})
				.then(() => {
					// pusher update will come and update so dont commit here
					// payload = response
					// payload.showBanner = true
					// commit(UPDATE_PODIUM, payload)
				})
		},
		getCustomBanners ({commit, getters}, options) {
			return axios.post(getters.apiPath + '/banner/', {
			    action: 'get_banner'
			});
		},
		recognizeBid ({commit, getters, state}, payload) {
			// If there is no bid to recognize, we can do nothing.
			if (!payload.bid_id) {
				return
			}
			commit(START_PROCESSING_BID, payload) // show spinner
			let podiumItem = state.podium
			if (
				podiumItem['upNext']['amount'] === null &&
				podiumItem['upNext']['bidcard'] === null &&
				podiumItem['upNext']['recognized'] === null &&
				podiumItem['upNext']['id'] === null
			) {
				axios
					.post(getters.apiPath + '/bid/', {
						x_auth_token: $cookies.get('llatoken'),
						bid_id: payload.bid_id,
						action: 'recognize_bid'
					})
					.then(() => {
						payload.hasUpNext = false
						commit(RECOGNIZE_BID, payload)
						commit(FINISH_PROCESSING_BID, payload)
					})
					.catch(() => {
						// We should finish processing even if api returns error.
						commit(FINISH_PROCESSING_BID, payload)
					})
			} else {
				payload.hasUpNext = true
				commit(RECOGNIZE_BID, payload)
				commit(FINISH_PROCESSING_BID, payload)
			}
		},

		// used to load the initial item values that are stored in the php footer
		saveItemData({ commit }, payload) {
			commit(SAVE_ITEMS, payload)
		},

		savePodiumState({ commit }, payload) {
			commit(SAVE_PODIUM_STATE, payload)
		},
		updateWebsiteMessage({ commit }, payload) {
			commit(UPDATE_WEBSITE_MESSAGE, payload)
		},
		getPhoneList({ commit, getters }, payload) {
			let postData = payload
			postData['x_auth_token'] = $cookies.get('llatoken')
			postData['action'] = 'individual_phone_list'
			axios.post(getters.apiPath + '/phone/', postData).then((response) => {
				commit(SAVE_PHONE_LIST, response.data)
			})
		},
		setCheckoutInvoiceId({ commit }, payload) {
			commit(SAVE_CHECKOUT_INVOICE_ID, payload)
		},
		updatePaymentForm({ commit }, payload) {
			commit(UPDATE_PAYMENT_FORM, payload)
		}
	}
})

// start the store poller for keeping track of the seconds remaining on a single lot page
store.dispatch('start')

export function renderComponent(component, selector, options, serviceLocations) {
	// If the element does not exist, do not render the component
	if (!document.querySelector(selector)) {
		return
	}
	const instance = new Vue({
		el: selector,
		store,
		data: {
			privateState: {},
			sharedState: store.state
		},
		render(h) {
			options.component = component
			options.serviceLocations = serviceLocations
			return h(DynamicComponent, { props: options })
		}
	})
	instance.$mount()
}

export function renderCheckoutComponent(component, selector, options, serviceLocations) {
	const instance = new Vue({
		el: selector,
		router,
		store,
		data() {
			return {
				privateState: {},
				sharedState: store.state
			}
		},
		render(h) {
			options.component = component
			options.serviceLocations = serviceLocations
			return h(DynamicComponent, { props: options })
		}
	})
	instance.$mount()
}

export function renderRouterComponent(component, selector, options, serviceLocations) {
	const instance = new Vue({
		el: selector,
		router,
		store,
		data: {
			privateState: {},
			sharedState: store.state
		},
		render(h) {
			options.component = component
			options.serviceLocations = serviceLocations
			return h(DynamicComponent, { props: options })
		}
	})
	instance.$mount()
}

// load the json item data that is embedded in the footer of the dynamic html output from php
export function loadItems(items) {
	store.dispatch('saveItemData', items)
}

export function getBiddingStatuses(itemIds) {
	store.dispatch('getBiddingStatuses', { item_ids: itemIds })
}

if (localStorage && version) {
	localStorage.setItem('APP_VERSION', version)
}

if (process.env.NODE_ENV === 'production') {
  // Only register service worker in production
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js');
    });
  }
} else {
  // In development, unregister any existing service worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        console.log('Unregistering service worker in development mode');
        registration.unregister();
      });
    });
  }
}
